import {
  FETCH_TRANS_PENDING,
  FETCH_TRANS_REJECTED,
  FETCH_TRANS_FULFILLED,
  FETCH_PLAYERS_PENDING,
  FETCH_PLAYERS_REJECTED,
  FETCH_PLAYERS_FULFILLED,
  FETCH_USER_TEAM_PENDING,
  FETCH_USER_TEAM_REJECTED,
  FETCH_USER_TEAM_FULFILLED,
  FETCH_REVEALED_TEAM_PENDING,
  FETCH_REVEALED_TEAM_REJECTED,
  FETCH_REVEALED_TEAM_FULFILLED,
  FETCH_PLAYER_CARD_PENDING,
  FETCH_PLAYER_CARD_REJECTED,
  FETCH_PLAYER_CARD_FULFILLED,
  FETCH_CONSTRAINTS_PENDING,
  FETCH_CONSTRAINTS_REJECTED,
  FETCH_CONSTRAINTS_FULFILLED,
  FETCH_FIXTURES_PENDING,
  FETCH_FIXTURES_REJECTED,
  FETCH_FIXTURES_FULFILLED,
  FETCH_PLAYER_STATS_PENDING,
  FETCH_PLAYER_STATS_REJECTED,
  FETCH_PLAYER_STATS_FULFILLED,
  FETCH_FAV_TEAM_PENDING,
  FETCH_FAV_TEAM_REJECTED,
  FETCH_FAV_TEAM_FULFILLED,
  ENABLE_DROP_MODE,
  DROP_ITEM,
  POST_SAVE_TEAM_PENDING,
  POST_SAVE_TEAM_REJECTED,
  POST_SAVE_TEAM_FULFILLED,
  POST_LOGIN_PENDING,
  POST_LOGIN_REJECTED,
  POST_LOGIN_FULFILLED,
  GET_My11_LOGIN_PENDING,
  GET_My11_LOGIN_REJECTED,
  GET_My11_LOGIN_FULFILLED,
  POST_My11_LOGOUT_PENDING,
  POST_My11_LOGOUT_REJECTED,
  POST_My11_LOGOUT_FULFILLED,
  POST_GDPR_PENDING,
  POST_GDPR_REJECTED,
  POST_GDPR_FULFILLED,
  FETCH_USER_BRACKET_FULFILLED,
  CHANGE_MODE,
  RESET_TEAM,
  SHOW_HIDE_POPUP,
  CHANGE_FORMATION,
  AFTER_CHANGE_FORMATION,
  CREATE_EMPTY_TEAM_BY_FORMATION,
  CHANGE_SKILL_TAB,
  ADD_PLAYER,
  REMOVE_PLAYER,
  SHOW_HIDE_PLAYERLISTING,
  ADD_REMOVED_PLAYER_FROM_FORMATION,
  REMOVE_REMOVED_PLAYER_FROM_FORMATION,
  ADD_PLAYER_FOR_CARD,
  REMOVE_PLAYER_FOR_CARD,
  SHOW_HIDE_OVERLAY,
  CHANGE_FILTER_TAB,
  CHANGE_FILTER_TAB_CHECKES,
  APPLY_FILTER,
  RESET_FILTER,
  CLOSE_FILTER,
  CHANGE_SORT_BY,
  CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION,
  CLEAR_PLAYER_SEARCH_ID,
  CHANGE_PLAYER_CARD_TAB,
  ADD_REMOVE_PLAYER,
  SELECT_C_VC,
  CHANGE_SORT_BY_TEAM,
  FETCH_PUBLIC_CONTEST_PENDING,
  FETCH_PUBLIC_CONTEST_REJECTED,
  FETCH_PUBLIC_CONTEST_FULFILLED,
  FETCH_PRIVATE_CONTEST_PENDING,
  FETCH_PRIVATE_CONTEST_REJECTED,
  FETCH_PRIVATE_CONTEST_FULFILLED,
  POST_CREATE_CONTEST_PENDING,
  POST_CREATE_CONTEST_REJECTED,
  POST_CREATE_CONTEST_FULFILLED,
  POST_JOIN_CONTEST_PENDING,
  POST_JOIN_CONTEST_REJECTED,
  POST_JOIN_CONTEST_FULFILLED,
  FETCH_CONTEST_LEADERBOARD_PENDING,
  FETCH_CONTEST_LEADERBOARD_REJECTED,
  FETCH_CONTEST_LEADERBOARD_FULFILLED,
  FETCH_GLOBAL_LEADERBOARD_PENDING,
  FETCH_GLOBAL_LEADERBOARD_REJECTED,
  FETCH_GLOBAL_LEADERBOARD_FULFILLED,
  FETCH_GLOBAL_LIVE_RANK_PENDING,
  FETCH_GLOBAL_LIVE_RANK_REJECTED,
  FETCH_GLOBAL_LIVE_RANK_FULFILLED,
  FETCH_FAVTEAM_LEADERBOARD_PENDING,
  FETCH_FAVTEAM_LEADERBOARD_REJECTED,
  FETCH_FAVTEAM_LEADERBOARD_FULFILLED,
  FETCH_FAVTEAM_LIVE_RANK_PENDING,
  FETCH_FAVTEAM_LIVE_RANK_REJECTED,
  FETCH_FAVTEAM_LIVE_RANK_FULFILLED,
  FETCH_CONTEST_NEWJOINEE_PENDING,
  FETCH_CONTEST_NEWJOINEE_REJECTED,
  FETCH_CONTEST_NEWJOINEE_FULFILLED,
  FETCH_TEAM_COMPARISON_PENDING,
  FETCH_TEAM_COMPARISON_REJECTED,
  FETCH_TEAM_COMPARISON_FULFILLED,
  SET_LAST_UPDATED_TIME,
  RESET_CONTEST_LEADERBOARD_DATA,
  CHANGE_SELECTED_FIXTURE,
  FETCH_USER_PLAYED_GAMEDAYS_PENDING,
  FETCH_USER_PLAYED_GAMEDAYS_REJECTED,
  FETCH_USER_PLAYED_GAMEDAYS_FULFILLED,
  POST_TRANSFER_TEAM_PENDING,
  POST_TRANSFER_TEAM_REJECTED,
  POST_TRANSFER_TEAM_FULFILLED,
  POST_CAPTAIN_TEAM_PENDING,
  POST_CAPTAIN_TEAM_REJECTED,
  POST_CAPTAIN_TEAM_FULFILLED,
  FETCH_TRANSFER_HISTORY_PENDING,
  FETCH_TRANSFER_HISTORY_REJECTED,
  FETCH_TRANSFER_HISTORY_FULFILLED,
  FETCH_TRANSFER_HISTORY_PLAYERS_PENDING,
  FETCH_TRANSFER_HISTORY_PLAYERS_REJECTED,
  FETCH_TRANSFER_HISTORY_PLAYERS_FULFILLED,
  FETCH_PLAYERS_STATS_PENDING,
  FETCH_PLAYERS_STATS_REJECTED,
  FETCH_PLAYERS_STATS_FULFILLED,
  CONTEST_APPLY_FILTER,
  CONTEST_CLOSE_FILTER,
  CONTEST_RESET_FILTER,
  CONTEST_CHANGE_FILTER_TAB_CHECKES,
  CONTEST_CHANGE_FILTER_TAB,
  FETCH_USER_TEAM_LIST_PENDING,
  FETCH_USER_TEAM_LIST_REJECTED,
  FETCH_USER_TEAM_LIST_FULFILLED,
  CHANGE_SELECTED_TEAM,
  FETCH_PLAYERS_LIVE_PENDING,
  FETCH_PLAYERS_LIVE_REJECTED,
  FETCH_PLAYERS_LIVE_FULFILLED,
  UPCOMING_FIXTURE,
  FETCH_GAMERCARD_PENDING,
  FETCH_GAMERCARD_FULFILLED,
  FETCH_GAMERCARD_REJECTED,
  FETCH_MIX_PENDING,
  FETCH_MIX_REJECTED,
  FETCH_MIX_FULFILLED,
  FETCH_WIDGET_PENDING,
  FETCH_WIDGET_REJECTED,
  FETCH_WIDGET_FULFILLED,
  IS_SHOW_MENU,
  FETCH_USER_STATS_PLAYER_PENDING,
  FETCH_USER_STATS_PLAYER_REJECTED,
  FETCH_USER_STATS_PLAYER_FULFILLED,
  FETCH_BOOSTERS_CONTRAINTS_PENDING,
  FETCH_BOOSTERS_CONTRAINTS_REJECTED,
  FETCH_BOOSTERS_CONTRAINTS_FULFILLED,
  CHANGE_BOOSTER,
  FETCH_BADGES_PENDING,
  FETCH_BADGES_REJECTED,
  FETCH_BADGES_FULFILLED,
  POST_REMOVE_LEAGUE_PENDING,
  POST_REMOVE_LEAGUE_REJECTED,
  POST_REMOVE_LEAGUE_FULFILLED,
  CHANGE_REMOVE_PLAYER,
  FETCH_USER_BADGES_PENDING,
  FETCH_USER_BADGES_REJECTED,
  FETCH_USER_BADGES_FULFILLED,
  FETCH_USER_BADGES_AFTER_POINT_CAL_PENDING,
  FETCH_USER_BADGES_AFTER_POINT_CAL_REJECTED,
  FETCH_USER_BADGES_AFTER_POINT_CAL_FULFILLED,
  SET_WRAPPER,
  POST_SAVE_BADGE_NOTIFY_PENDING,
  POST_SAVE_BADGE_NOTIFY_REJECTED,
  POST_SAVE_BADGE_NOTIFY_FULFILLED,
  UPDATE_USER_BADGES_PENDING,
  UPDATE_USER_BADGES_REJECTED,
  UPDATE_USER_BADGES_FULFILLED,
  UPDATE_USER_BADGES,
  UPDATE_UNLOCKED_BADGES,
  UPDATE_UNLOCKED_BADGES_TEAM,
  RESET_STORE,
  SHOW_HIDE_PULLTO_REFRESH,
  AKAMAI_TIMER_CALL_PENDING,
  AKAMAI_TIMER_CALL_REJECTED,
  AKAMAI_TIMER_CALL_FULFILLED,
  POST_TEAM_NAME_SUBMIT_PENDING,
  POST_TEAM_NAME_SUBMIT_REJECTED,
  POST_TEAM_NAME_SUBMIT_FULFILLED,
  FETCH_CTR_FAV_DATA_PENDING,
  FETCH_CTR_FAV_DATA_REJECTED,
  FETCH_CTR_FAV_DATA_FULFILLED,
  POST_PROFILE_UPDATE_SUBMIT_PENDING,
  POST_PROFILE_UPDATE_SUBMIT_REJECTED,
  POST_PROFILE_UPDATE_SUBMIT_FULFILLED,
  FETCH_PROFILE_DATA_PENDING,
  FETCH_PROFILE_DATA_REJECTED,
  FETCH_PROFILE_DATA_FULFILLED,
  SHOULD_DELETE_BOOSTER,
  FETCH_VICE_CAPTAIN_LEADERBOARD_PENDING,
  FETCH_CAPTAIN_LEADERBOARD_PENDING,
  FETCH_CAPTAIN_LEADERBOARD_REJECTED,
  FETCH_CAPTAIN_LEADERBOARD_FULFILLED,
  FETCH_CAPTAIN_LIVE_RANK_PENDING,
  FETCH_CAPTAIN_LIVE_RANK_REJECTED,
  FETCH_CAPTAIN_LIVE_RANK_FULFILLED,
  FETCH_VICE_CAPTAIN_LEADERBOARD_REJECTED,
  FETCH_VICE_CAPTAIN_LEADERBOARD_FULFILLED,
  FETCH_VICE_CAPTAIN_LIVE_RANK_PENDING,
  FETCH_VICE_CAPTAIN_LIVE_RANK_REJECTED,
  FETCH_VICE_CAPTAIN_LIVE_RANK_FULFILLED,
  FETCH_KNOCKOUT_LEADERBOARD_PENDING,
  FETCH_KNOCKOUT_LEADERBOARD_REJECTED,
  FETCH_KNOCKOUT_LEADERBOARD_FULFILLED,
  FETCH_KNOCKOUT_LIVE_RANK_PENDING,
  FETCH_KNOCKOUT_LIVE_RANK_REJECTED,
  FETCH_KNOCKOUT_LIVE_RANK_FULFILLED,
  FETCH_CONFIG_DATA_PENDING,
  FETCH_CONFIG_DATA_REJECTED,
  FETCH_CONFIG_DATA_FULFILLED,
  FETCH_USER_POINTS_HISTORY_PENDING,
  FETCH_USER_POINTS_HISTORY_REJECTED,
  FETCH_USER_POINTS_HISTORY_FULFILLED,
  GET_MY_RANK,
  VIEW_TEAM,
  BOOSTER_RESET,
  IS_HEADER_DATA,
} from "./../../actionTypes";
import config from "./../../../common/config";
import core from "./../../../common/core";
import app from "./../../../common/app";
import { find, orderBy, uniq } from "lodash";
import objUrl, {
  playersAPI,
  getUserTeamUrl,
  getOtherUserTeamUrl,
  getMyTeamListAPI,
  getMyTeamListOverallAPI,
  playerStatsAPI,
  playersCardAPI,
  getPublicContest,
  getPrivateContest,
  getGlobalLeaderboard,
  getFavTeamLeaderboard,
  getContestLeaderboard,
  playerStatisticsAPI,
  getUserTeamLiveUrl,
  playersLiveAPI,
  getOtherUserTeamLiveUrl,
  getMyTeamListLiveAPI,
  getMyTeamListOverallLiveAPI,
  playerStatsLiveAPI,
  playersCardLiveAPI,
  getLivePublicContest,
  getLivePrivateContest,
  getLiveGlobalLeaderboard,
  getLiveFavTeamLeaderboard,
  getLiveContestLeaderboard,
  playerStatisticsLiveAPI,
  getLiveCaptainLeaderboard,
  getLiveViceCaptainLeaderboard,
  getCaptainLeaderboard,
  getViceCaptainLeaderboard,
  getKnockoutLeaderboard,
  getLiveKnockoutLeaderboard,
} from "./../../apiUrls";
//get in local storage
let parseBadges = { leagueBadges: null, userBadges: null };
const cookieLog = app.getLoginCookie();
// if (cookieLog) {
//   const sBadegs = core.getLocalStorageValue(config.badgesStorage);
//   const objBadgeStorage = JSON.parse(sBadegs);
//   if (objBadgeStorage && objBadgeStorage[cookieLog.UserId]) {
//     parseBadges = objBadgeStorage[cookieLog.UserId];
//   }
// }
const initialState = {
  isGameStatus: config.enumGameStatus.open,
  isLoading: false,
  isTransLoading: false,
  isTransError: false,
  isTransSuccess: false,
  trans: {},
  //
  isPlayersLoading: false,
  isPlayersError: false,
  isPlayersSuccess: false,
  arrPlayers: null,
  //
  isUserTeamLoading: false,
  isUserTeamError: false,
  isUserTeamSuccess: false,
  arrUserTeam: null,
  //
  isRevealedTeamLoading: false,
  isRevealedTeamError: false,
  isRevealedTeamSuccess: false,
  arrRevealedTeam: null,
  //
  isPlayerCardLoading: false,
  isPlayerCardError: false,
  isPlayerCardSuccess: false,
  arrPlayerCard: null,
  //
  isConstraintsLoading: false,
  isConstraintsError: false,
  isConstraintsSuccess: false,
  objContraints: null,
  //
  isLoginLoading: false,
  isLoginError: false,
  isLoginSuccess: false,
  objLogin: null,
  //
  isMy11LoginLoading: false,
  isMy11LoginError: false,
  isMy11LoginSuccess: false,
  objMy11Login: null,
  //
  isMy11LogoutLoading: false,
  isMy11LogoutError: false,
  isMy11LogoutSuccess: false,
  //
  isGdprLoading: false,
  isGdprError: false,
  isGdprSuccess: false,
  objGdpr: null,
  //
  isFixturesLoading: false,
  isFixturesError: false,
  isFixturesSuccess: false,
  arrFixtures: [],
  totalMatches: 0,
  userEotStatus: config.enumEotScenarios.no_eot,
  jAutorefreshFixture: 0,
  jAutorefreshSelectedFixture: 0,
  //
  isPlayerStatsLoading: false,
  isPlayerStatsError: false,
  isPlayerSuccess: false,
  isPlayerStatsSuccess: false,
  objPlayerStats: null,
  //
  isFavTeamLoading: false,
  isFavTeamError: false,
  isFavTeamSuccess: false,
  arrFavTeam: null,

  jFixtures: config.emptyValue,
  uFixture: config.emptyValue,
  isSaveLoading: false,
  isSaveError: false,
  isSaveSuccess: false,
  save: {},
  arrSelectedPlayerRevealed: {},
  objDrag: { id: config.emptyValue, groupId: config.emptyValue },
  jMode: config.enumMode.open,
  objPopup: null,
  arrSkillFiltreTab: [],
  jSkillFiltreTab: config.emptyValue,
  playerCardFilterTab: config.emptyValue,
  jSkillFiltreTabPlayer: config.emptyValue,
  isOpenPlayerListing: false,
  jAvoidFiltreIndex: config.emptyValue,
  objPlayerCardFiltreIndex: null,
  hasTeam: false,
  sAddPlayerError: "",
  resultCompId: config.emptyValue,
  objOverlay: null,
  arrFiltresTab: [
    {
      id: config.enumTabsId.creditRange,
      transKey: "creaditRange",
      arrDetails: [],
    },
    { id: config.enumTabsId.teams, transKey: "teams", arrDetails: [] },
    { id: config.enumTabsId.matches, transKey: "matches", arrDetails: [] },
    {
      id: config.enumTabsId.nationality,
      transKey: "nationality",
      arrDetails: [],
    },
    {
      id: config.enumTabsId.skill,
      transKey: "skill",
      arrDetails: [],
    },
    // {
    //   id: config.enumTabsId.uncap,
    //   transKey: "uncapFilter",
    //   arrDetails: [],
    // },
  ],
  jFiltresTab: config.emptyValue,
  arrSortingColumn: [
    // {
    //   id: 4,
    //   transKey: "teams",
    //   sortingColumn: "TeamName",
    //   className: "m11c-tbl__cell--thumb",
    // },
    {
      id: 2,
      transKey: "points",
      sortingColumn: "OverallPoints",
      className: "m11c-tbl__cell--name",
      // sortByDesc: true,
    },
    {
      id: 1,
      transKey: "selectedBy",
      sortingColumn: "SelectedPer",
      className: "m11c-tbl__cell--pts",
    },
    {
      id: 3,
      transKey: "creadits",
      sortingColumn: "Value",
      className: "m11c-tbl__cell--amt",
    },
  ],
  arrSortingColumnTeam: [
    // {
    //   id: 1,
    //   transKey: "team",
    //   sortingColumn: "TeamShortName",
    //   className: "m11c-tbl__cell--thumb",
    //   sortByDesc: true,
    // },
    {
      id: 2,
      transKey: "points",
      sortingColumn: "OverallPoints",
      className: "m11c-tbl__cell--name",
    },
    {
      id: 3,
      transKey: "capSelectedPer",
      sortingColumn: "CapSelectedPer",
      className: "m11c-tbl__cell--captn",
    },
    {
      id: 4,
      transKey: "vCapSelectedPer",
      sortingColumn: "VCapSelectedPer",
      className: "m11c-tbl__cell--captn",
    },
  ],
  jSelectedSortingColumnTeam: -1,
  jSelectedSortingColumn: -1,
  jPlayerIdAfterSearch: config.emptyValue,
  jPlayerCardTab: config.emptyValue,
  arrSelectedPlayer: config.arrSelectedPlayer,
  arrSelectedPlayerDefault: config.arrSelectedPlayer,

  isPublicContestLoading: false,
  isPublicContestError: false,
  isPublicContestSuccess: false,
  publicContestList: null,

  isPrivateContestLoading: false,
  isPrivateContestError: false,
  isPrivateContestSuccess: false,
  privateContestList: null,

  isCretContestLoading: false,
  isCretContestError: false,
  isCretContestSuccess: false,
  cretContestRes: null,

  isJoinContestLoading: false,
  isJoinContestError: false,
  isJoinContestSuccess: false,
  joinContestRes: null,

  isContestLeaderboardLoading: false,
  isContestLeaderboardError: false,
  isContestLeaderboardSuccess: false,
  contestLeaderboardMyRes: [],
  contestLeaderboardRes: [],
  leaderboardLastUpdated: null,

  isGlobalLeaderboardLoading: false,
  isGlobalLeaderboardError: false,
  isGlobalLeaderboardSuccess: false,

  isGlobalLeaderboardRankLoading: false,
  isGlobalLeaderboardRankError: false,
  isGlobalLeaderboardRankSuccess: false,

  isFavTeamLeaderboardLoading: false,
  isFavTeamLeaderboardError: false,
  isFavTeamLeaderboardSuccess: false,

  isFavTeamLeaderboardRankLoading: false,
  isFavTeamLeaderboardRankError: false,
  isFavTeamLeaderboardRankSuccess: false,

  isCaptainLeaderboardLoading: false,
  isCaptainLeaderboardError: false,
  isCaptainLeaderboardSuccess: false,

  isCaptainLeaderboardRankLoading: false,
  isCaptainLeaderboardRankError: false,
  isCaptainLeaderboardRankSuccess: false,

  isViceCaptainLeaderboardLoading: false,
  isViceCaptainLeaderboardError: false,
  isViceCaptainLeaderboardSuccess: false,

  isViceCaptainLeaderboardRankLoading: false,
  isViceCaptainLeaderboardRankError: false,
  isViceCaptainLeaderboardRankSuccess: false,

  isKnockoutLeaderboardLoading: false,
  isKnockoutLeaderboardError: false,
  isKnockoutLeaderboardSuccess: false,

  isKnockoutLeaderboardRankLoading: false,
  isKnockoutLeaderboardRankError: false,
  isKnockoutLeaderboardRankSuccess: false,

  isContestNewJoineeLoading: false,
  isContestNewJoineeError: false,
  isContestNewJoineeSuccess: false,
  contestNewJoineeRes: [],

  isTeamComparisonLoading: false,
  isTeamComparisonError: false,
  isTeamComparisonSuccess: false,
  teamComparisonData: [],

  isSelectedFixture: false,
  //
  isUserPlayedGameDaysLoading: false,
  isUserPlayedGameDaysError: false,
  isUserPlayedGameDaysSuccess: false,
  objUserPlayedGameDays: null,

  isCaptainLoading: false,
  isCaptainError: false,
  isCaptainSuccess: false,
  captain: null,

  isTransferLoading: false,
  isTransferError: false,
  isTransferSuccess: false,
  transfer: null,
  objUserTeam: null,
  currUserTeam: null,

  isTransferHistoryLoading: false,
  isTransferHistoryError: false,
  isTransferHistorySuccess: false,
  transferHistory: null,

  isTransferHistoryPlayersLoading: false,
  isTransferHistoryPlayersError: false,
  isTransferHistoryPlayersSuccess: false,
  transferHistoryPlayers: null,

  isPlayerStatisticsLoading: false,
  isPlayerStatisticsError: false,
  isPlayerStatisticsSuccess: false,
  sortedPlayers: null,
  matchDayGroup: null,
  arrContestFilterTab: [
    // TODO: add tab options
    {
      id: config.enumTabsId.skill,
      transKey: "skill",
      arrDetails: [],
    },
    { id: config.enumTabsId.matches, transKey: "matches", arrDetails: [] },
    { id: config.enumTabsId.teams, transKey: "teams", arrDetails: [] },
    // {
    //   id: config.enumTabsId.nationality,
    //   transKey: "nationality",
    //   arrDetails: [],
    // },
    // {
    //   id: config.enumTabsId.uncap,
    //   transKey: "uncapFilter",
    //   arrDetails: [],
    // },
    // {
    //   id: config.enumTabsId.creditRange,
    //   transKey: "creaditRange",
    //   arrDetails: [],
    // },
  ],
  jContestFiltresTab: config.emptyValue,
  isMyTeamListingLoading: false,
  isMyTeamListingError: false,
  isMyTeamListingSuccess: false,
  objMyTeamListing: null,
  arrMyTeamListing: [],
  isLivePlayersLoading: false,
  isLivePlayersError: false,
  isLivePlayersSuccess: false,
  arrLivePlayers: [],

  isGamerCardLoading: false,
  isGamerCardError: false,
  isGamerCardSuccess: false,
  gamerCardsObj: {},
  //
  isMixLoading: false,
  isMixError: false,
  isMixSuccess: false,
  objMix: null,
  //
  isWidgetLoading: false,
  isWidgetError: false,
  isWidgetSuccess: false,
  arrWidget: null,
  showMenu: true,
  headersData: null,
  isShowPlayerStats: false,

  isUserPlayerStatsLoading: false,
  isUserPlayerStatsError: false,
  isUserPlayerStatsSuccess: false,
  objUserPlayerStats: null,
  arrUserPlayerStats: [],
  isAutoSaved: false,
  jErrorcode: config.enumErrorCode.normal,
  objBooster: null,
  isBoostersConstraintLoading: false,
  isBoostersConstraintError: false,
  isBoostersConstraintSuccess: false,
  arrBoostersConstraint: null,
  isBadgesLoading: false,
  isBadgesError: false,
  isBadgesSuccess: false,
  arrBadges: null,
  isRemoveLeagueLoading: false,
  isRemoveLeagueError: false,
  isRemoveLeagueSuccess: false,
  objRemoveLeague: null,
  isUserBadgesLoading: false,
  isUserBadgesError: false,
  isUserBadgesSuccess: false,
  $wrapMain: null,
  isBdgNotifyLoading: false,
  isBdgNotifyError: false,
  isBdgNotifySuccess: true,
  arrUserBadges: parseBadges,
  isShowPullToRefresh: 1,

  isAkamaiTimerLoading: false,
  isAkamaiTimerError: false,
  isAkamaiTimerSuccess: false,

  isTeamNameLoading: false,
  isTeamNameError: false,
  isTeamNameSuccess: false,
  teamNameRes: null,

  isSelectDataLoading: false,
  isSelectDataError: false,
  isSelectDataSuccess: false,
  SelectDataRes: null,

  isProfileUpdateLoading: false,
  isProfileUpdateError: false,
  isProfileUpdateSuccess: false,
  profileUpdateRes: null,

  isProfileDateLoading: false,
  isProfileDateError: false,
  isProfileDateSuccess: false,
  profileDateRes: null,
  shouldDeleteBoosterVal: false,

  isUserPtsHistoryLoading: false,
  isUserPtsHistoryError: false,
  isUserPtsHistorySuccess: false,
  userPtsHistoryRes: null,
  shouldDeleteBoosterVal: false,

  isMyRank: false,
};
const makeLive = (groupedFixtures, hasTeam, isAvoidLiveUrls) => {
  const recentFixture = app.getRecentFixture(groupedFixtures, hasTeam);

  const isLive =
    recentFixture &&
    (recentFixture.status == config.enumFixtureType.isLock ||
      recentFixture.status == config.enumFixtureType.isEnded);
  if (isLive) {
    objUrl.playersAPI = playersLiveAPI;
    objUrl.getUserTeamUrl = getUserTeamLiveUrl;
    objUrl.getOtherUserTeamUrl = getOtherUserTeamLiveUrl;
    objUrl.getMyTeamListAPI = getMyTeamListLiveAPI;
    objUrl.getMyTeamListOverallAPI = getMyTeamListOverallLiveAPI;
    objUrl.playerStatsAPI = playerStatsLiveAPI;
    objUrl.playersCardAPI = playersCardLiveAPI;
    // if (isAvoidLiveUrls) {
    //   objUrl.getUserTeamUrl = getUserTeamUrl;
    // }
    objUrl.getPublicContest = getLivePublicContest;
    objUrl.getPrivateContest = getLivePrivateContest;
    objUrl.getGlobalLeaderboard = getLiveGlobalLeaderboard;
    objUrl.getCaptainLeaderboard = getLiveCaptainLeaderboard;
    objUrl.getViceCaptainLeaderboard = getLiveViceCaptainLeaderboard;
    objUrl.getKnockoutLeaderboard = getLiveKnockoutLeaderboard;
    objUrl.getFavTeamLeaderboard = getLiveFavTeamLeaderboard;
    objUrl.getContestLeaderboard = getLiveContestLeaderboard;
    objUrl.playerStatisticsAPI = playerStatisticsLiveAPI;
  } else {
    objUrl.playersAPI = playersAPI;
    objUrl.getUserTeamUrl = getUserTeamUrl;
    objUrl.getOtherUserTeamUrl = getOtherUserTeamUrl;
    objUrl.getMyTeamListAPI = getMyTeamListAPI;
    objUrl.getMyTeamListOverallAPI = getMyTeamListOverallAPI;
    objUrl.playerStatsAPI = playerStatsAPI;
    objUrl.playersCardAPI = playersCardAPI;
    objUrl.getPublicContest = getPublicContest;
    objUrl.getPrivateContest = getPrivateContest;
    objUrl.getGlobalLeaderboard = getGlobalLeaderboard;
    objUrl.getFavTeamLeaderboard = getFavTeamLeaderboard;
    objUrl.getCaptainLeaderboard = getCaptainLeaderboard;
    objUrl.getViceCaptainLeaderboard = getViceCaptainLeaderboard;
    objUrl.getKnockoutLeaderboard = getKnockoutLeaderboard;
    objUrl.getContestLeaderboard = getContestLeaderboard;
    objUrl.playerStatisticsAPI = playerStatisticsAPI;
  }

  if (app.fetchLivePlayers(recentFixture)) {
    objUrl.playersAPI = playersLiveAPI;
  }
};
export default function appData(state = initialState, action) {
  switch (action.type) {
    /** START API */
    ////////////////get//////////////////////
    case FETCH_TRANS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLoading: true,
        isTransLoading: true,
        isTransError: false,
        isTransSuccess: false,
      };
    }
    case FETCH_TRANS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isLoading: false,
        isTransLoading: false,
        isTransError: true,
        isTransSuccess: false,
      };
    }
    case FETCH_TRANS_FULFILLED: {
      let trans = null;
      if (action.payload.data && action.payload.data.value) {
        trans = action.payload.data.value.Translations;
        config.offSetText =
          trans && trans.offSetText ? trans.offSetText : config.offSetText;
      }
      //core.setLoader();
      return {
        ...state,
        isLoading: false,
        isTransLoading: false,
        isTransError: false,
        isTransSuccess: true,
        trans: trans,
      };
    }

    case FETCH_PLAYERS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPlayersLoading: true,
        isPlayersError: false,
        isPlayersSuccess: false,
      };
    }
    case FETCH_PLAYERS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPlayersLoading: false,
        isPlayersError: true,
        isPlayersSuccess: false,
      };
    }
    case FETCH_PLAYERS_FULFILLED: {
      let arrPlayers = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrPlayers = action.payload.data.Data.Value.Players;
        for (let j = 0; j < (arrPlayers || []).length; j++) {
          arrPlayers[j].SkillOrder =
            config.enumSortingOrder[arrPlayers[j].SkillId];
          // //TODO:remove
          // if (arrPlayers[j].Id === 63706) {
          //   arrPlayers[j].isUncap = true
          // }
        }
        //add teams tab value
        const { arrFiltresTab, arrContestFilterTab } = state;
        let arrFiltresTabT = [];
        let arrContestFilterTabT = [];
        let arrDetailSort = [];
        for (let j = 0; j < (arrFiltresTab || []).length; j++) {
          const objRow = arrFiltresTab[j];
          let arrDetails = objRow.arrDetails;
          if (objRow.id === config.enumTabsId.teams) {
            for (let jN = 0; jN < (arrPlayers || []).length; jN++) {
              if (arrDetails.length >= 1) {
                arrDetails = arrDetails.sort((a, b) => {
                  if (a.value < b.value) {
                    return -1;
                  }
                  if (a.value > b.value) {
                    return 1;
                  }
                });
              }
              const objPlayer = arrPlayers[jN];
              const jIndex = core.getIndexOfArrayByValue(
                arrDetails,
                "id",
                objPlayer.TeamId
              );
              if (jIndex === -1) {
                arrDetails.push({
                  id: objPlayer.TeamId,
                  value: objPlayer.TeamName,
                  checked: false,
                  defaultChecked: false,
                  tempChecked: false,
                });
              }
            }
          }
          arrFiltresTabT.push({ ...objRow, arrDetails: arrDetails });
        }

        // for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
        //   const objRow = arrContestFilterTab[j];
        //   let arrDetails = objRow.arrDetails;
        //   if (objRow.id === config.enumTabsId.teams) {
        //     for (let jN = 0; jN < (arrPlayers || []).length; jN++) {
        //       const objPlayer = arrPlayers[jN];
        //       const jIndex = core.getIndexOfArrayByValue(
        //         arrDetails,
        //         "id",
        //         objPlayer.TeamId
        //       );
        //       if (jIndex === -1) {
        //         arrDetails.push({
        //           id: objPlayer.TeamId,
        //           value: objPlayer.TeamName,
        //           checked: false,
        //           defaultChecked: false,
        //           tempChecked: false
        //         });
        //       }
        //     }
        //   }

        //   arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetails });
        // }
        return {
          ...state,
          isPlayersLoading: false,
          isPlayersError: false,
          isPlayersSuccess: true,
          arrPlayers: arrPlayers,
          arrFiltresTab: arrFiltresTabT,
        };
      }
      //core.setLoader();
      // if (arrPlayers && arrPlayers.length) {
      //     arrPlayers = arrPlayers.sort((a, b) => {
      //         const sAPlayerDisplayName = a.PlayerDisplayName;
      //         const sBPlayerDisplayName = b.PlayerDisplayName;
      //         if (sAPlayerDisplayName < sBPlayerDisplayName) {
      //             return -1;
      //         }
      //         if (sAPlayerDisplayName > sBPlayerDisplayName) {
      //             return 1;
      //         }
      //         // a must be equal to b
      //         return 0;
      //     });
      // }
      return {
        ...state,
        isPlayersLoading: false,
        isPlayersError: false,
        isPlayersSuccess: true,
        arrPlayers: arrPlayers,
      };
    }

    case FETCH_USER_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUserTeamLoading: true,
        isUserTeamError: false,
        isUserTeamSuccess: false,
      };
    }
    case FETCH_USER_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserTeamLoading: false,
        isUserTeamError: true,
        isUserTeamSuccess: false,
      };
    }

    case FETCH_REVEALED_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isRevealedTeamLoading: true,
        isRevealedTeamError: false,
        isRevealedTeamSuccess: false,
      };
    }
    case FETCH_REVEALED_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isRevealedTeamLoading: false,
        isRevealedTeamError: true,
        isRevealedTeamSuccess: false,
      };
    }
    case FETCH_REVEALED_TEAM_FULFILLED: {
      let arrRevealedTeam = null;
      let jFormation = state.jFormation;
      let arrFormations = state.arrFormations;
      let arrSelectedPlayerMain = state.arrSelectedPlayerRevealed;
      let hasTeam = state.hasTeam;
      let resultCompId = state.resultCompId;
      if (action.payload.data.data && action.payload.data.data.value) {
        arrRevealedTeam = action.payload.data.data.value;
        let objFormation = null;
        for (let j = 0; j < (arrFormations || []).length; j++) {
          const objRow = arrFormations[j];
          if (objRow.CompId === arrRevealedTeam.unvieledMDCompId) {
            objFormation = objRow;
            resultCompId = objFormation.CompId;
            //jFormation = j;
            break;
          }
        }
        arrSelectedPlayerMain = app.creteEmptyTeamFormation(
          objFormation,
          state.trans
        );
        let arrRevealedTeamPlayer = arrRevealedTeam.unvieledTeams;
        loop1: for (let j = 0; j < (arrRevealedTeamPlayer || []).length; j++) {
          const objRowTeamPlayer = arrRevealedTeamPlayer[j];
          loop2: for (let jKey in arrSelectedPlayerMain) {
            const arrSkill = arrSelectedPlayerMain[jKey];
            loop3: for (let jN = 0; jN < (arrSkill || []).length; jN++) {
              let objSkill = arrSkill[jN];
              if (
                objSkill.filterIndex === config.emptyValue &&
                objSkill.skill === objRowTeamPlayer.skill
              ) {
                objSkill.filterIndex = objRowTeamPlayer.id;
                break loop2;
              }
            }
          }
        }
      }
      //core.setLoader();
      return {
        ...state,
        isRevealedTeamLoading: false,
        isRevealedTeamError: false,
        isRevealedTeamSuccess: true,
        arrRevealedTeam: arrRevealedTeam,
        arrSelectedPlayerRevealed: arrSelectedPlayerMain,
        resultCompId: resultCompId,
      };
    }

    case FETCH_PLAYER_CARD_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        arrPlayerCard: null,
        isPlayerCardLoading: true,
        isPlayerCardError: false,
        isPlayerCardSuccess: false,
      };
    }
    case FETCH_PLAYER_CARD_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPlayerCardLoading: false,
        isPlayerCardError: true,
        isPlayerCardSuccess: false,
      };
    }
    case FETCH_PLAYER_CARD_FULFILLED: {
      let arrPlayerCard = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrPlayerCard = action.payload.data.Data.Value;
      }
      if (arrPlayerCard) {
        let { Completed, Upcoming } = arrPlayerCard;
        if (Completed && Completed.length) {
          Completed = Completed.map((ele, jIndex) => {
            if (ele.MatchDate && ele.MatchDate.indexOf("GMT") === -1) {
              ele.MatchDate = `${ele.MatchDate} GMT`;
            }
            if (ele.Venue1) {
              const sVenue2 = ele.Venue1;
              let sVenue3 = `${sVenue2}`;
              sVenue3 = sVenue3.replace("International Sportspark", "ISP");
              sVenue3 = sVenue3.replace("Bellerive Oval", "Blundstone Arena");
              sVenue3 = sVenue3.replace(
                "Brisbane Cricket Ground (Woolloongabba)",
                "The Gabba"
              );
              sVenue3 = sVenue3.replace(
                "Aurora Stadium",
                "University of Tasmania Stadium"
              );
              sVenue3 = sVenue3.replace("Carrara Oval", "Metricon Stadium");
              sVenue3 = sVenue3.replace("Perth Stadium", "Optus Stadium");
              sVenue3 = sVenue3.replace("Docklands Stadium", "Marvel Stadium");
              ele.Venue1 = sVenue3;
            }
            return { ...ele };
          });
        }
        if (Upcoming && Upcoming.length) {
          Upcoming = Upcoming.map((ele, jIndex) => {
            if (ele.MatchDate && ele.MatchDate.indexOf("GMT") === -1) {
              ele.MatchDate = `${ele.MatchDate} GMT`;
            }
            if (ele.Venue1) {
              const sVenue2 = ele.Venue1;
              let sVenue3 = `${sVenue2}`;
              sVenue3 = sVenue3.replace("International Sportspark", "ISP");
              sVenue3 = sVenue3.replace("Bellerive Oval", "Blundstone Arena");
              sVenue3 = sVenue3.replace(
                "Brisbane Cricket Ground (Woolloongabba)",
                "The Gabba"
              );
              sVenue3 = sVenue3.replace(
                "Aurora Stadium",
                "University of Tasmania Stadium"
              );
              sVenue3 = sVenue3.replace("Carrara Oval", "Metricon Stadium");
              sVenue3 = sVenue3.replace("Perth Stadium", "Optus Stadium");
              sVenue3 = sVenue3.replace("Docklands Stadium", "Marvel Stadium");
              ele.Venue1 = sVenue3;
            }
            return { ...ele };
          });
        }
        arrPlayerCard = { ...arrPlayerCard, Completed, Upcoming };
      }
      //core.setLoader();
      return {
        ...state,
        isPlayerCardLoading: false,
        isPlayerCardError: false,
        isPlayerCardSuccess: true,
        arrPlayerCard: arrPlayerCard,
      };
    }

    case FETCH_FIXTURES_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isFixturesLoading: true,
        isFixturesError: false,
        isFixturesSuccess: false,
      };
    }
    case FETCH_FIXTURES_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFixturesLoading: false,
        isFixturesError: true,
        isFixturesSuccess: false,
      };
    }
    case FETCH_FIXTURES_FULFILLED: {
      let arrFixtures = [];
      let totalMatches = 0;
      let isShowPlayerStats = false;
      let { jFixtures, hasTeam } = state;
      let jFixturesTemp = core.getLocalStorageValue(config.FixturesId);

      if (jFixturesTemp || (jFixturesTemp && Number(jFixturesTemp) === 0)) {
        jFixtures = Number(jFixturesTemp);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrFixtures = action.payload.data.Data.Value;
        // totalMatches = arrFixtures.length;
        const arrResultFixtures = arrFixtures.map((ele, jIndex) => {
          if (Number(ele.IsActiveForNewUser)) {
            ele.IsCurrent = 1;
          }
          if (ele.MatchdateTime && ele.MatchdateTime.indexOf("GMT") === -1) {
            ele.MatchdateTime = `${ele.MatchdateTime} GMT`;
          }
          const jMdStatus = app.getFixtureStatusByRow(ele);
          if (
            jMdStatus == config.enumFixtureType.isLock ||
            jMdStatus == config.enumFixtureType.isFinished ||
            jMdStatus == config.enumFixtureType.isEnded ||
            jMdStatus == config.enumFixtureType.isAbandoned ||
            jMdStatus == config.enumFixtureType.isPostponed
          ) {
            isShowPlayerStats = true;
          }
          if (ele.Venue1) {
            const sVenue2 = ele.Venue1;
            let sVenue3 = `${sVenue2}`;
            sVenue3 = sVenue3.replace("International Sportspark", "ISP");
            sVenue3 = sVenue3.replace("Bellerive Oval", "Blundstone Arena");
            sVenue3 = sVenue3.replace(
              "Brisbane Cricket Ground (Woolloongabba)",
              "The Gabba"
            );
            sVenue3 = sVenue3.replace(
              "Aurora Stadium",
              "University of Tasmania Stadium"
            );
            sVenue3 = sVenue3.replace("Carrara Oval", "Metricon Stadium");
            sVenue3 = sVenue3.replace("Perth Stadium", "Optus Stadium");
            sVenue3 = sVenue3.replace("Docklands Stadium", "Marvel Stadium");
            ele.Venue1 = sVenue3;
          }
          return { ...ele };
        });

        let finalMatch =
          arrFixtures && arrFixtures.length
            ? arrFixtures[arrFixtures.length - 1]
            : null;
        let tourCurrStatus = app.getTourStatus(finalMatch, hasTeam);
        let matchdayList = app.getGdForMatchFile(arrResultFixtures);
        let groupedFixtures = app.generateFixtureArray(arrResultFixtures);

        //Matches
        const { arrFiltresTab, trans } = state;
        let arrFiltresTabT = [];
        for (let j = 0; j < (arrFiltresTab || []).length; j++) {
          const objRow = arrFiltresTab[j];
          let arrDetails = []; //objRow.arrDetails;
          if (objRow.id === config.enumTabsId.matches) {
            for (let jN = 0; jN < (arrResultFixtures || []).length; jN++) {
              const objFixture = arrResultFixtures[jN];
              let jStatus = app.getFixtureStatusByRow(objFixture);
              const jIndex = core.getIndexOfArrayByValue(
                arrDetails,
                "id",
                objFixture.MatchId
              );
              if (jIndex === -1) {
                const sLabel = `${objFixture.HomeTeamShortName} ${
                  trans && trans.vs ? trans.vs : "vs"
                } ${objFixture.AwayTeamShortName}`;
                //Changed Date
                const gmtMatchdateTime = core.convertTimeToOffset(
                  objFixture.MatchdateTime,
                  config.offSetToAdd
                );
                const sDesc = `${objFixture.MatchNumber}, ${core.dateFormat(
                  gmtMatchdateTime,
                  "mmm d, h:MM TT"
                )}`;
                // ${config.offSetText}
                if (
                  objFixture.HomeTeamId &&
                  objFixture.AwayTeamId &&
                  (jStatus === config.enumFixtureType.isOpen ||
                    jStatus === config.enumFixtureType.isUpcomming)
                ) {
                  arrDetails.push({
                    id: objFixture.MatchId,
                    value: sLabel,
                    checked: false,
                    defaultChecked: false,
                    tempChecked: false,
                    desc: sDesc,
                  });
                }
              }
            }
          } else if (objRow.id === config.enumTabsId.skill) {
            arrDetails.push({
              id: config.enumPosition.wk,
              value: `${
                trans && trans.wicketKeepers
                  ? trans.wicketKeepers
                  : "Wicket-Keepers"
              }`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
            arrDetails.push({
              id: config.enumPosition.bat,
              value: `${trans && trans.batsmen ? trans.batsmen : "Batters"}`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
            arrDetails.push({
              id: config.enumPosition.ar,
              value: `${
                trans && trans.allRounders ? trans.allRounders : "All-Rounders"
              }`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
            arrDetails.push({
              id: config.enumPosition.bowl,
              value: `${trans && trans.bowlers ? trans.bowlers : "Bowlers"}`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
          } else if (objRow.id === config.enumTabsId.nationality) {
            arrDetails.push({
              id: config.enumNationalityIds.indian,
              value: `${trans && trans.indian ? trans.indian : "Indian"}`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
            arrDetails.push({
              id: config.enumNationalityIds.foreign,
              value: `${trans && trans.foreign ? trans.foreign : "Overseas"}`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
          } else if (objRow.id === config.enumTabsId.creditRange) {
            arrDetails.push({
              id: 1,
              value:
                trans && trans.creditRange1
                  ? trans.creditRange1
                  : // : "6 and below",
                    "Less than 7",
              checked: false,
              defaultChecked: false,
              tempChecked: false,
              min: -1,
              max: 7,
            });
            arrDetails.push({
              id: 2,
              value: trans && trans.creditRange2 ? trans.creditRange2 : "7 - 9",
              checked: false,
              defaultChecked: false,
              tempChecked: false,
              min: 6.5,
              max: 9.5,
            });
            arrDetails.push({
              id: 3,
              value:
                trans && trans.creditRange3
                  ? trans.creditRange3
                  : "More than 9",
              checked: false,
              defaultChecked: false,
              tempChecked: false,
              min: 9,
              max: -1,
            });
            // arrDetails.push({
            //   id: 4,
            //   value:
            //     trans && trans.creditRange4 ? trans.creditRange4 : "10.5-12",
            //   checked: false,
            //   defaultChecked: false,
            //   tempChecked: false,
            //   min: 10.5,
            //   max: -1,
            // });
            // arrDetails.push({
            //   id: 5,
            //   value:
            //     trans && trans.creditRange5
            //       ? trans.creditRange5
            //       : "12.5 and above",
            //   checked: false,
            //   defaultChecked: false,
            //   tempChecked: false,
            //   min: 12.5,
            //   max: -1,
            // });
          } else if (objRow.id === config.enumTabsId.uncap) {
            arrDetails.push({
              id: config.enumCapFilterIds.cap,
              value: `${
                trans && trans.capPlayer ? trans.capPlayer : "Capped Player"
              }`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
            arrDetails.push({
              id: config.enumCapFilterIds.uncap,
              value: `${
                trans && trans.uncapPlayer
                  ? trans.uncapPlayer
                  : "Uncapped Player"
              }`,
              checked: false,
              defaultChecked: false,
              tempChecked: false,
            });
          }
          arrFiltresTabT.push({ ...objRow, arrDetails: arrDetails });
        }
        totalMatches = groupedFixtures ? groupedFixtures.length : 0;

        // let favTeam = uniq(arrFixtures, "HomeTeamId");

        // const favTeam = [];

        // let unqiId = [...new Set(arrFixtures.map((item) => item.HomeTeamId))];

        //         arrFixtures.map((f) => {
        // let tVal = {}

        //         });

        // let favTeam =

        // [
        //   ...new Set(
        //     arrFixtures.map((a) => {
        //       return { [a.AwayTeamId]: a.AwayTeamName };
        //     })
        //   ),
        // ];

        // for (let i = 0; i < arrFixtures.length; i++) {
        //   const fix = arrFixtures[i];
        //   let tVal = { [fix.HomeTeamId]: fix.HomeTeamName };
        //   if (!favTeam.includes(tVal)) {
        //     favTeam.push(tVal);
        //   }
        // }
        // console.log("~ favTeam", favTeam);

        // for (let i = 0; i < groupedFixtures.length; i++) {
        //   const fix = groupedFixtures[i];
        //   if (fix.Gameday == 1) {
        //     // console.log(fix);
        //     // fix.IsLocked = 1;
        //     // fix.IsCurrent = 1;
        //     fix.IsLineupAnnounced = 1;
        //   }
        // }

        makeLive(groupedFixtures, hasTeam);

        return {
          ...state,
          isFixturesLoading: false,
          isFixturesError: false,
          isFixturesSuccess: true,
          arrFixtures: groupedFixtures,
          finalMatch: finalMatch,
          jFixtures: jFixtures,
          arrFiltresTab: arrFiltresTabT,
          isShowPlayerStats: isShowPlayerStats,
          totalMatches: totalMatches,
          matchdayList: matchdayList,
          userEotStatus: tourCurrStatus,
          jAutorefreshFixture: state.jAutorefreshFixture + 1,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          isFixturesLoading: false,
          isFixturesError: false,
          isFixturesSuccess: true,
        };
      }
    }

    case FETCH_CONSTRAINTS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isConstraintsLoading: true,
        isConstraintsError: false,
        isConstraintsSuccess: false,
      };
    }
    case FETCH_CONSTRAINTS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isConstraintsLoading: false,
        isConstraintsError: true,
        isConstraintsSuccess: false,
      };
    }
    case FETCH_CONSTRAINTS_FULFILLED: {
      let objContraints = null;
      let arrSkillFiltreTab = state.arrSkillFiltreTab;
      if (action.payload.data && action.payload.data.Data) {
        objContraints = action.payload.data.Data.Value;
        arrSkillFiltreTab = objContraints.CompositionSkills;
      }
      for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
        const objSkill = arrSkillFiltreTab[j];
        config.enumMinPositionNos[objSkill.SkillId] = objSkill.MinPlayerCount;
        config.enumMaxPositionNos[objSkill.SkillId] = objSkill.MaxPlayerCount;
      }

      return {
        ...state,
        isConstraintsLoading: false,
        isConstraintsError: false,
        isConstraintsSuccess: true,
        objContraints: objContraints,
        arrSkillFiltreTab: arrSkillFiltreTab,
      };
    }

    case FETCH_FAV_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isFavTeamLoading: true,
        isFavTeamError: false,
        isFavTeamSuccess: false,
      };
    }
    case FETCH_FAV_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFavTeamLoading: false,
        isFavTeamError: true,
        isFavTeamSuccess: false,
      };
    }
    case FETCH_FAV_TEAM_FULFILLED: {
      let arrFavTeam = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrFavTeam = action.payload.data.Data.Value;
      }
      //core.setLoader();
      return {
        ...state,
        isFavTeamLoading: false,
        isFavTeamError: false,
        isFavTeamSuccess: true,
        arrFavTeam: arrFavTeam,
      };
    }
    case FETCH_USER_PLAYED_GAMEDAYS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUserPlayedGameDaysLoading: true,
        isUserPlayedGameDaysError: false,
        isUserPlayedGameDaysSuccess: false,
      };
    }
    case FETCH_USER_PLAYED_GAMEDAYS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayedGameDaysLoading: false,
        isUserPlayedGameDaysError: true,
        isUserPlayedGameDaysSuccess: false,
      };
    }
    case FETCH_USER_PLAYED_GAMEDAYS_FULFILLED: {
      let objUserPlayedGameDays = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objUserPlayedGameDays = action.payload.data.Data.Value;
      }
      let hasTeam = state.hasTeam;
      if (objUserPlayedGameDays) {
        hasTeam = objUserPlayedGameDays.ftgdid;
      }
      let finalMatch = state.finalMatch;
      let tourCurrStatus = state.userEotStatus;
      if (finalMatch && hasTeam) {
        tourCurrStatus = app.getTourStatus(finalMatch, hasTeam);
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayedGameDaysLoading: false,
        isUserPlayedGameDaysError: false,
        isUserPlayedGameDaysSuccess: true,
        objUserPlayedGameDays: objUserPlayedGameDays,
        hasTeam: hasTeam,
        userEotStatus: tourCurrStatus,
      };
    }
    case FETCH_USER_TEAM_FULFILLED: {
      let arrUserTeam = [];
      let arrPrevUserTeam = [];

      const { arrPlayers } = state;
      let arrPlayersInTeam = [];
      let arrPrevPlayersInTeam = [];
      // const { jMaxTeamPlayers } = action.meta;
      let arrSelectedPlayerMain = [];
      const arrSelectedPlayerT = state.arrSelectedPlayer;
      let arrSelectedPlayerDefault = [];
      let hasTeam = state.hasTeam;
      let parseJSON = null;
      let prevIds = [];
      if (action.payload.data.Data && action.payload.data.Data.Value) {
        parseJSON = action.payload.data.Data.Value;
        // prevMhTeam = parseJSON.prplyid;
        for (let j = 0; j < (parseJSON?.plyid || []).length; j++) {
          const objId = parseJSON?.plyid[j];
          const objSkillId = parseJSON?.plyskl[j];
          arrUserTeam.push({ Id: objId, SkillId: objSkillId });
        }
        for (let jN = 0; jN < (arrUserTeam || []).length; jN++) {
          let rowTeam = arrUserTeam[jN];
          const jPlayerId = Number(rowTeam.Id);
          const jSkill = Number(rowTeam.SkillId);
          const isCaptain = parseJSON.mcapt === jPlayerId;
          const isViceCaptain = parseJSON.vcapt === jPlayerId;
          const isImpactPlayer = parseJSON.bcapt === jPlayerId;

          arrSelectedPlayerMain.push({
            Id: jPlayerId,
            SkillId: jSkill,
            isCaptain: isCaptain,
            isViceCaptain: isViceCaptain,
            isImpactPlayer,
          });
        }

        const arrIn = [];
        const arrOut = [];
        arrPlayers &&
          arrPlayers.forEach((ele) => {
            let len = arrUserTeam.findIndex((eleT) => {
              return ele.Id === eleT.Id;
            });
            if (len > -1) {
              arrIn.push(ele);
            } else {
              arrOut.push(ele);
            }
          });
        arrIn.forEach((ele) => {
          arrPlayersInTeam.push(ele);
        });
        arrOut.forEach((ele) => {
          arrPlayersInTeam.push(ele);
        });

        for (
          let j = 0;
          j < (parseJSON?.prplyid || parseJSON?.plyid || []).length;
          j++
        ) {
          const objFixture = app.getSelectedFixture(
            state.arrFixtures,
            state.jFixtures
          );
          let objId;
          if (parseJSON?.gdid) {
            objId =
              objFixture?.Gameday == parseJSON?.gdid &&
              objFixture?.Gameday != state.objUserPlayedGameDays.ftgdid
                ? parseJSON?.prplyid[j]
                : parseJSON?.plyid[j];
          } else {
            objId = parseJSON?.plyid[j];
          }
          prevIds.push(objId);
          const objPlayer = app.getPlayerDetails(state?.arrPlayers, objId);
          const objSkillId = objPlayer.SkillId;
          arrPrevUserTeam.push({ Id: objId, SkillId: objSkillId });
        }

        for (let jN = 0; jN < (arrPrevUserTeam || []).length; jN++) {
          let rowTeam = arrPrevUserTeam[jN];
          const jPlayerId = Number(rowTeam.Id);
          const jSkill = Number(rowTeam.SkillId);
          const isCaptain = parseJSON.mcapt === jPlayerId;
          const isViceCaptain = parseJSON.vcapt === jPlayerId;
          const isImpactPlayer = parseJSON.bcapt === jPlayerId;
          arrSelectedPlayerDefault.push({
            Id: jPlayerId,
            SkillId: jSkill,
            isCaptain: isCaptain,
            isViceCaptain: isViceCaptain,
            isImpactPlayer,
          });
        }
      }

      // let arrSelectedPlayerDefault = [];
      // core.deepCopy(arrSelectedPlayerDefault, arrSelectedPlayerMain);
      let arrSelectedPlayer = [];
      core.deepCopy(arrSelectedPlayer, arrSelectedPlayerMain);
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }

      // const objFixture = app.getSelectedFixture(
      //   state.arrFixtures,
      //   state.jFixtures
      // );

      let currIds = parseJSON?.plyid;
      // let prevIds =
      //   objFixture.Gameday !== parseJSON.gdid
      //     ? parseJSON.plyid
      //     : parseJSON.prplyid;

      let prevTeam = prevIds
        ?.map((id) => state?.arrPlayers?.find((pl) => pl.Id == id))
        ?.filter(Boolean); // Ensures only valid player objects are included
      // debugger;

      let currTeam = currIds
        ?.map((id) => state?.arrPlayers?.find((pl) => pl.Id == id))
        ?.filter(Boolean); // Ensures only valid player objects are included

      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserTeamLoading: false,
        isUserTeamError: false,
        isUserTeamSuccess: true,
        arrUserTeam: arrUserTeam,
        // arrSelectedPlayer: arrSelectedPlayer,
        arrSelectedPlayer: app.sortPlayersBySkill(arrSelectedPlayer),
        arrSelectedPlayerDefault: arrSelectedPlayerDefault,
        objUserTeam: parseJSON,
        arrPlayers: arrPlayersInTeam,
        arrPrevPlayersInTeam: [],
        currUserTeam: currTeam,
        prevUserTeam: prevTeam,
      };
    }
    ////////////////get//////////////////////

    ////////////////post/////////////////////
    case POST_SAVE_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isSaveLoading: true,
        isSaveError: false,
        isSaveSuccess: false,
      };
    }
    case POST_SAVE_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isSaveLoading: false,
        isSaveError: true,
        isSaveSuccess: false,
      };
    }
    case POST_SAVE_TEAM_FULFILLED: {
      let save = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        //console.log(action.payload.data.value);
        save = action.payload.data.Data.Value;
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isSaveLoading: false,
        isSaveError: false,
        isSaveSuccess: true,
        save: save,
        isAutoSaved: false,
      };
    }
    case POST_TRANSFER_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isTransferLoading: true,
        isTransferError: false,
        isTransferSuccess: false,
      };
    }
    case POST_TRANSFER_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferLoading: false,
        isTransferError: true,
        isTransferSuccess: false,
      };
    }
    case POST_TRANSFER_TEAM_FULFILLED: {
      let transfer = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        //console.log(action.payload.data.value);
        transfer = action.payload.data.Data.Value;
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferLoading: false,
        isTransferError: false,
        isTransferSuccess: true,
        transfer: transfer,
      };
    }
    case POST_CAPTAIN_TEAM_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isCaptainLoading: true,
        isCaptainError: false,
        isCaptainSuccess: false,
      };
    }
    case POST_CAPTAIN_TEAM_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCaptainLoading: false,
        isCaptainError: true,
        isCaptainSuccess: false,
      };
    }
    case POST_CAPTAIN_TEAM_FULFILLED: {
      let Captain = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        //console.log(action.payload.data.value);
        Captain = action.payload.data.Data.Value;
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCaptainLoading: false,
        isCaptainError: false,
        isCaptainSuccess: true,
        captain: Captain,
      };
    }
    case POST_LOGIN_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLoginLoading: true,
        isLoginError: false,
        isLoginSuccess: false,
      };
    }
    case POST_LOGIN_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isLoginLoading: false,
        isLoginError: true,
        isLoginSuccess: false,
      };
    }
    case POST_LOGIN_FULFILLED: {
      let objLogin = null;
      if (action.payload.data && action.payload.data.value) {
        //console.log(action.payload.data.value);
        objLogin = action.payload.data.value;
      }
      //core.setLoader();
      return {
        ...state,
        isLoginLoading: false,
        isLoginError: false,
        isLoginSuccess: true,
        objLogin: objLogin,
      };
    }
    case GET_My11_LOGIN_PENDING: {
      return {
        ...state,
        isMy11LoginLoading: true,
        isMy11LoginError: false,
        isMy11LoginSuccess: false,
      };
    }
    case GET_My11_LOGIN_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMy11LoginLoading: false,
        isMy11LoginError: true,
        isMy11LoginSuccess: false,
      };
    }
    case GET_My11_LOGIN_FULFILLED: {
      let apiData = null;
      if (action.payload.data && action.payload.data.value) {
        apiData = action.payload.data.value;
      }

      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMy11LoginLoading: false,
        isMy11LoginError: false,
        isMy11LoginSuccess: true,
        objMy11Login: apiData,
      };
    }
    case POST_My11_LOGOUT_PENDING: {
      return {
        ...state,
        isMy11LogoutLoading: true,
        isMy11LogoutError: false,
        isMy11LogoutSuccess: false,
      };
    }
    case POST_My11_LOGOUT_REJECTED: {
      // let jErrorcode = config.enumErrorCode.normal;
      // if (action.payload && action.payload.response && action.payload.response.status) {
      //   const jStatusCode = action.payload.response.status;
      //   jErrorcode = app.setErrorCode(jStatusCode);
      // }
      return {
        ...state,
        // jErrorcode: jErrorcode,
        isMy11LogoutLoading: false,
        isMy11LogoutError: true,
        isMy11LogoutSuccess: false,
      };
    }
    case POST_My11_LOGOUT_FULFILLED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (action.payload && action.payload.status) {
        const jStatusCode = action.payload.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMy11LogoutLoading: false,
        isMy11LogoutError: false,
        isMy11LogoutSuccess: true,
        objMy11Login: null,
      };
    }
    case POST_GDPR_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isGdprLoading: true,
        isGdprError: false,
        isGdprSuccess: false,
      };
    }
    case POST_GDPR_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGdprLoading: false,
        isGdprError: true,
        isGdprSuccess: false,
      };
    }
    case POST_GDPR_FULFILLED: {
      //core.setLoader();
      return {
        ...state,
        isGdprLoading: false,
        isGdprError: false,
        isGdprSuccess: true,
      };
    }
    ////////////////post/////////////////////
    /** END API */
    case ENABLE_DROP_MODE: {
      return {
        ...state,
        objDrag: { ...action.payload.objDrag },
        jMode: action.payload.jMode,
      };
    }

    case SHOW_HIDE_POPUP: {
      return {
        ...state,
        objPopup: { ...state.objPopup, ...action.payload },
      };
    }
    case CHANGE_FORMATION: {
      return {
        ...state,
        jFormation: action.payload,
      };
    }
    case SHOW_HIDE_PLAYERLISTING: {
      return {
        ...state,
        isOpenPlayerListing: action.payload,
      };
    }
    case AFTER_CHANGE_FORMATION: {
      const { objFormation, jAvoidFiltreIndex } = action.payload;
      const { arrSelectedPlayer, jFormation } = state;
      const arrSelectedPlayerMain = app.creteEmptyTeamFormation(
        objFormation,
        state.trans
      );

      const arrFWDOld = arrSelectedPlayer[config.enumPosition.forwards];
      const arrMIDOld = arrSelectedPlayer[config.enumPosition.midfielders];
      const arrDEFOld = arrSelectedPlayer[config.enumPosition.defenders];
      const arrGKOld = arrSelectedPlayer[config.enumPosition.goalkeepers];

      let arrFWDNew = arrSelectedPlayerMain[config.enumPosition.forwards];
      let arrMIDNew = arrSelectedPlayerMain[config.enumPosition.midfielders];
      let arrDEFNew = arrSelectedPlayerMain[config.enumPosition.defenders];
      let arrGKNew = arrSelectedPlayerMain[config.enumPosition.goalkeepers];

      //Forwards
      arrFWDNew = app.creatrNewSkillRow(
        arrFWDOld,
        arrFWDNew,
        jAvoidFiltreIndex
      );
      //Midfielders
      arrMIDNew = app.creatrNewSkillRow(
        arrMIDOld,
        arrMIDNew,
        jAvoidFiltreIndex
      );
      //Defenders
      arrDEFNew = app.creatrNewSkillRow(
        arrDEFOld,
        arrDEFNew,
        jAvoidFiltreIndex
      );
      //Goakippers
      arrGKNew = app.creatrNewSkillRow(arrGKOld, arrGKNew, jAvoidFiltreIndex);
      const objTab = app.getCurrentSelectedTabIndexes(
        null,
        state.arrSkillFiltreTab,
        arrSelectedPlayerMain
      );
      core.setLocalStorageValue(config.formationId, jFormation);
      core.setLocalStorageValue(
        config.tempSelectedPlayerCookieName,
        JSON.stringify(arrSelectedPlayerMain)
      );
      return {
        ...state,
        arrSelectedPlayer: arrSelectedPlayerMain,
        jSkillFiltreTab: objTab.jSkillFiltreTab,
        jSkillFiltreTabPlayer: objTab.jSkillFiltreTabPlayer,
        jAvoidFiltreIndex: config.emptyValue,
      };
    }
    case CREATE_EMPTY_TEAM_BY_FORMATION: {
      const {
        isEmpty,
        arrSelectedPlayer,
        TeamGamedayId,
        isFromFavTeam,
        objBooster,
      } = action.payload;
      const {
        hasTeam,
        arrSelectedPlayer: arrSelectedPlayerT,
        objBooster: objBoosterT,
      } = state;
      let arrSelectedPlayerMain = hasTeam
        ? arrSelectedPlayerT
        : arrSelectedPlayer;
      let objBoosterMain = hasTeam ? objBoosterT : objBooster;
      let isAutoSaved = false;
      // let arrSelectedPlayerCookie = core.getLocalStorageValue(
      //   config.tempSelectedPlayerCookieName
      // );
      // let arrSelectedPlayerTemp = JSON.parse(arrSelectedPlayerCookie);
      // if (arrSelectedPlayerTemp) {
      //   arrSelectedPlayerMain = arrSelectedPlayerTemp;
      // }
      let tempTeamGamedayId = core?.getLocalStorageValue(
        config.tempTeamGamedayId
      );
      if (isEmpty || Number(tempTeamGamedayId) !== Number(TeamGamedayId)) {
        core.removeLocalStorageValue(config.tempSelectedPlayerCookieName);
        core.removeLocalStorageValue(config.tempTeamGamedayId);
        core.removeLocalStorageValue(config.tempTeamObjBooster);
        //only for create team reset
        if (!hasTeam || !arrSelectedPlayerMain) {
          arrSelectedPlayerMain = config.arrSelectedPlayer;
          objBoosterMain = null;
        }
      } else if (isFromFavTeam) {
        let cookie = app.getLoginCookie();
        let jFavTeamId = 0;
        if (cookie) {
          jFavTeamId = Number(cookie.FavTeamId);
        }
        if (jFavTeamId) {
          isAutoSaved = true;
        }
      }

      let currTeam = [];
      if (!hasTeam) {
        let plyIds = arrSelectedPlayerMain?.map((pl) => pl.Id);
        currTeam = state.arrPlayers.filter((pl) => plyIds.includes(pl.Id));
        // ?.map((pl) => {
        //   return { Id: pl.Id, TeamId: pl.TeamId };
        // });
      }
      return hasTeam
        ? {
            ...state,
            arrSelectedPlayer: arrSelectedPlayerMain,
            objBooster: objBoosterMain,
            isAutoSaved: isAutoSaved,
          }
        : {
            ...state,
            arrSelectedPlayer: arrSelectedPlayerMain,
            objBooster: objBoosterMain,
            isAutoSaved: isAutoSaved,
            currUserTeam: currTeam,
          };
    }

    case CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION: {
      const {
        arrFiltresTab,
        jSkillFiltreTab,
        arrSkillFiltreTab,
        arrPlayers,
        arrFixtures,
      } = state;
      const { PlayerId } = action.payload;
      let jSkillFiltreTabP = jSkillFiltreTab;
      const objSkillTab = app.getSelectedPosition(
        arrSkillFiltreTab,
        jSkillFiltreTabP
      );
      const jSkill = objSkillTab ? objSkillTab.SkillId : 0;
      let arrFiltresTabT = arrFiltresTab;
      //
      let fFound = false;
      let fPlayersFoundInSkill = false;
      for (let j = 0; j < arrPlayers.length; j++) {
        const ele = arrPlayers[j];
        if (jSkill === ele.SkillId) {
          fFound = app.isFoundPlayerFromFilter(
            arrFiltresTabT,
            ele,
            arrFixtures
          );
          if (PlayerId === ele.Id) {
            fPlayersFoundInSkill = true;
          }
        }
      }
      if (!fFound || !fPlayersFoundInSkill) {
        loop1: for (let jN = 0; jN < arrSkillFiltreTab.length; jN++) {
          const objSkillFiltreTab = arrSkillFiltreTab[jN];
          for (let j = 0; j < arrPlayers.length; j++) {
            const ele = arrPlayers[j];
            if (objSkillFiltreTab.SkillId === ele.SkillId) {
              fFound = app.isFoundPlayerFromFilter(
                arrFiltresTabT,
                ele,
                arrFixtures
              );
              if (fFound) {
                if (PlayerId === ele.Id) {
                  jSkillFiltreTabP = jN;
                  fPlayersFoundInSkill = true;
                  break loop1;
                }
              }
            }
          }
        }
      }
      //
      return {
        ...state,
        jSkillFiltreTab: jSkillFiltreTabP,
        jPlayerIdAfterSearch: PlayerId,
      };
    }
    case CLEAR_PLAYER_SEARCH_ID: {
      return {
        ...state,
        jPlayerIdAfterSearch: config.emptyValue,
      };
    }
    case APPLY_FILTER: {
      const {
        arrFiltresTab,
        jSkillFiltreTab,
        arrSkillFiltreTab,
        arrPlayers,
        arrFixtures,
        trans,
      } = state;
      let jSkillFiltreTabP = jSkillFiltreTab;
      const objSkillTab = app.getSelectedPosition(
        arrSkillFiltreTab,
        jSkillFiltreTabP
      );
      const jSkill = objSkillTab ? objSkillTab.SkillId : 0;
      let arrFiltresTabT = [];
      let analyticsEvent = [];
      for (let j = 0; j < (arrFiltresTab || []).length; j++) {
        const objRow = arrFiltresTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          arrDetails[jN] = {
            ...arrDetails[jN],
            checked:
              arrDetails[jN]
                .tempChecked /*tempChecked: arrDetails[jN].defaultChecked*/,
          };
          if (arrDetails[jN].checked) {
            // analyticsEvent.push({ ...arrDetails[jN], rowId: objRow.id, transKey: objRow.transKey });
            const sFName =
              objRow.transKey; /* trans && trans[objRow.transKey] ? trans[objRow.transKey] : config.enumEventPage.applyFilterButton.label */
            let jLastIndexOf = app.getGroupByValue(
              analyticsEvent,
              "tabName",
              sFName
            );
            analyticsEvent.push({
              sKey: sFName + (jLastIndexOf + 1),
              tabName: sFName,
              value: arrDetails[jN].value,
            });
          }
        }
        arrFiltresTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      // // console.log('analyticsEvent', analyticsEvent);
      let objExtra = {};
      const values = [];
      for (let j = 0; j < (analyticsEvent || []).length; j++) {
        const rowAnalyticsEvent = analyticsEvent[j];
        values.push(rowAnalyticsEvent.value);
        // objExtra[rowAnalyticsEvent.sKey] = rowAnalyticsEvent.value;
      }
      //Analytics Event
      /* rowAnalyticsEvent.value;// */
      let action = config.enumEventPage.applyFilterButton.action;
      let category = config.enumEventPage.applyFilterButton.category;
      let opt_label = config.enumEventPage.applyFilterButton.label;
      objExtra = { filterd: values, filterCount: values.length };
      false &&
        app.googleAnalyticsEventTracking(action, category, opt_label, objExtra);
      /*//
      /* trans && trans[rowAnalyticsEvent.transKey] ? trans[rowAnalyticsEvent.transKey] :  config.enumEventPage.applyFilterButton.label;*/
      const cookie = app.getLoginCookie();
      app.gaEventTrigger({
        UserId: cookie?.UserId,
        tournament: config.tournament,
        filterd: values,
        filterCount: values.length,
        event: opt_label,
      });
      let fFound = false;
      for (let j = 0; j < arrPlayers.length; j++) {
        const ele = arrPlayers[j];
        if (jSkill === ele.SkillId) {
          fFound = app.isFoundPlayerFromFilter(
            arrFiltresTabT,
            ele,
            arrFixtures
          );
        }
      }
      if (!fFound) {
        loop1: for (let jN = 0; jN < arrSkillFiltreTab.length; jN++) {
          const objSkillFiltreTab = arrSkillFiltreTab[jN];
          for (let j = 0; j < arrPlayers.length; j++) {
            const ele = arrPlayers[j];
            if (objSkillFiltreTab.SkillId === ele.SkillId) {
              fFound = app.isFoundPlayerFromFilter(
                arrFiltresTabT,
                ele,
                arrFixtures
              );
              if (fFound) {
                // jSkillFiltreTabP = jN;
                break loop1;
              }
            }
          }
        }
      }
      //*/
      return {
        ...state,
        arrFiltresTab: arrFiltresTabT,
        jSkillFiltreTab: jSkillFiltreTabP,
      };
    }
    case CLOSE_FILTER: {
      const { arrFiltresTab } = state;
      let arrFiltresTabT = [];
      for (let j = 0; j < (arrFiltresTab || []).length; j++) {
        const objRow = arrFiltresTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          if (!arrDetails[jN].checked) {
            arrDetails[jN] = {
              ...arrDetails[jN],
              tempChecked: arrDetails[jN].defaultChecked,
            };
          } else {
            arrDetails[jN] = {
              ...arrDetails[jN],
              tempChecked: arrDetails[jN].checked,
            };
          }
        }
        arrFiltresTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      return {
        ...state,
        arrFiltresTab: arrFiltresTabT,
      };
    }
    case RESET_FILTER: {
      const { arrFiltresTab } = state;
      let arrFiltresTabT = [];
      for (let j = 0; j < (arrFiltresTab || []).length; j++) {
        const objRow = arrFiltresTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          arrDetails[jN] = {
            ...arrDetails[jN],
            checked: arrDetails[jN].defaultChecked,
            tempChecked: arrDetails[jN].defaultChecked,
          };
        }
        arrFiltresTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      return {
        ...state,
        arrFiltresTab: arrFiltresTabT,
      };
    }
    case CHANGE_SKILL_TAB: {
      const { jSkillFiltreTab } = action.payload;
      let jSkillFiltreTabP = jSkillFiltreTab;
      return {
        ...state,
        jSkillFiltreTab: jSkillFiltreTabP,
      };
    }
    case CHANGE_FILTER_TAB: {
      const { jFiltresTab } = action.payload;
      let jFiltresTabP = jFiltresTab;
      return {
        ...state,
        jFiltresTab: jFiltresTabP,
      };
    }
    case CHANGE_SORT_BY: {
      const { jSelectedSortingColumn, isLoadTime } = action.payload;
      const {
        arrSortingColumn,
        jSelectedSortingColumn: jSelectedSortingColumnOld,
        arrPlayers,
      } = state;

      let jSelectedSortingColumnP = jSelectedSortingColumn;
      let arrPlayerListingSorted = arrPlayers;
      let arrSortingColumnT = [];
      let sortByDesc = true;
      for (let j = 0; j < arrSortingColumn.length; j++) {
        let row = arrSortingColumn[j];
        if (row.sortByDesc) {
          sortByDesc = row.sortByDesc;
        }
      }
      for (let j = 0; j < arrSortingColumn.length; j++) {
        let row = arrSortingColumn[j];
        if (jSelectedSortingColumn === j) {
          if (jSelectedSortingColumnOld !== jSelectedSortingColumn) {
            arrSortingColumnT.push({ ...row, sortByDesc: sortByDesc });
            /*arrPlayerListingSorted = arrPlayers.sort(function (a, b) {
                            let jFltrSortBy = row.sortingColumn;
                            let valueA = a[jFltrSortBy];
                            let valueB = b[jFltrSortBy];
                            valueA = valueA ? (+(valueA)) : 0;
                            valueB = valueB ? (+(valueB)) : 0;

                            if (valueA > valueB) {
                                return -1;
                            }
                            if (valueA < valueB) {
                                return 1;
                            }

                            return 0;
                        });*/
          } else {
            if (!isLoadTime) {
              sortByDesc = !row.sortByDesc;
            } else {
              sortByDesc = row.sortByDesc;
            }
            arrSortingColumnT.push({ ...row, sortByDesc: sortByDesc });
          }
          arrPlayerListingSorted =
            arrPlayers &&
            arrPlayers.sort(function (a, b) {
              let jFltrSortBy = row.sortingColumn;
              let valueA = a[jFltrSortBy];
              let valueB = b[jFltrSortBy];

              if (!isNaN(valueA)) {
                valueA = valueA ? +valueA : 0;
                valueB = valueB ? +valueB : 0;
              }

              if (sortByDesc) {
                if (valueA > valueB) {
                  return -1;
                }
                if (valueA < valueB) {
                  return 1;
                }
              } else {
                if (valueA > valueB) {
                  return 1;
                }
                if (valueA < valueB) {
                  return -1;
                }
              }

              return 0;
            });
        } else {
          arrSortingColumnT.push({ ...row, sortByDesc: false });
        }
      }

      // code for showing playing player first then not playing
      if (jSelectedSortingColumnOld === -1) {
        let announcedPly = arrPlayerListingSorted
          ?.filter((pl) => pl.IsAnnounced == "P")
          .sort((a, b) => b.Value - a.Value);

        let notAnnouncedPly = arrPlayerListingSorted
          ?.filter((pl) => pl.IsAnnounced === "NP")
          .sort((a, b) => b.Value - a.Value);
        let subStituePly = arrPlayerListingSorted
          ?.filter((pl) => pl.IsAnnounced === "S")
          .sort((a, b) => b.Value - a.Value);

        let remaningPly = arrPlayerListingSorted?.filter(
          (pl) =>
            pl.IsAnnounced !== "S" &&
            pl.IsAnnounced !== "NP" &&
            pl.IsAnnounced !== "P"
        );
        // announcedPly.sort((a, b) => b.Value - a.Value);
        // subStituePly.sort((a, b) => b.Value - a.Value);
        // notAnnouncedPly.sort((a, b) => b.Value - a.Value);
        // remaningPly.sort((a, b) => b.Value - a.Value);

        arrPlayerListingSorted = [
          ...announcedPly,
          ...subStituePly,
          ...notAnnouncedPly,
          ...remaningPly,
        ];
      }
      return {
        ...state,
        jSelectedSortingColumn: jSelectedSortingColumnP,
        arrSortingColumn: arrSortingColumnT,
        arrPlayers: arrPlayerListingSorted,
      };
    }
    case CHANGE_FILTER_TAB_CHECKES: {
      const { jFiltresTab, jIndex, sChecked } = action.payload;
      const { arrFiltresTab } = state;
      let arrFiltresTabT = [];
      for (let j = 0; j < (arrFiltresTab || []).length; j++) {
        const objRow = arrFiltresTab[j];
        let arrDetails = objRow.arrDetails;
        let arrDetailsT = [];
        if (jFiltresTab === j) {
          for (let jN = 0; jN < (arrDetails || []).length; jN++) {
            arrDetailsT.push({ ...arrDetails[jN] });
            if (jIndex === jN) {
              arrDetailsT[jN][sChecked] = !arrDetailsT[jN][sChecked];
              //break;
            }
          }
        } else {
          arrDetailsT = arrDetails;
        }
        arrFiltresTabT.push({ ...objRow, arrDetails: arrDetailsT });
      }
      return {
        ...state,
        arrFiltresTab: arrFiltresTabT,
      };
    }
    case ADD_REMOVE_PLAYER: {
      const { hasTeam } = state;
      const { arrSelectedPlayer, TeamGamedayId, currPlayerIds } =
        action.payload;
      if (!hasTeam && TeamGamedayId) {
        core.setLocalStorageValue(
          config.tempSelectedPlayerCookieName,
          JSON.stringify(arrSelectedPlayer)
        );
        core.setLocalStorageValue(
          config.tempTeamGamedayId,
          JSON.stringify(TeamGamedayId)
        );
        // console.log("curr", currPlayerIds);

        // Create a clean player object with only required properties
        const cleanPlayerData =
          currPlayerIds?.map((player) => ({
            Id: player.Id,
            TeamId: player.TeamId,
            PlayerDisplayName: player.PlayerDisplayName,
            SkillId: player.SkillId,
            Value: player.Value,
          })) || [];

        // Store the clean data
        core.setLocalStorageValue(
          config.createTeamStorage,
          JSON.stringify(cleanPlayerData)
        );
      }

      return {
        ...state,
        arrSelectedPlayer: arrSelectedPlayer,
        currUserTeam: currPlayerIds,
      };
    }
    case REMOVE_PLAYER: {
      const { arrSelectedPlayer, jFormation } = state;
      let arrSelectedPlayerMain = app.breakRefInSelection(arrSelectedPlayer);
      let { jId, jSkill } = action.payload;
      const arrSkill = arrSelectedPlayerMain[jSkill];
      //const arrSkillNew = [];
      //const arrSkillNewEmpty = [];
      for (let jN = 0; jN < (arrSkill || []).length; jN++) {
        let objSkill = arrSkill[jN];
        if (objSkill.filterIndex === jId) {
          objSkill.filterIndex = config.emptyValue;
        }
        // if (objSkill.filterIndex === jId) {
        //     objSkill.filterIndex = config.emptyValue;
        //     arrSkillNewEmpty.push({ ...objSkill });
        // }
        // else {
        //     arrSkillNew.push({ ...objSkill });
        // }
      }
      // for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
      //     let objSkill = arrSkillNewEmpty[jN];
      //     arrSkillNew.push({ ...objSkill });
      // }
      arrSelectedPlayerMain[jSkill] = arrSkill;
      const objTab = app.getCurrentSelectedTabIndexes(
        state.jSkillFiltreTab,
        state.arrSkillFiltreTab,
        arrSelectedPlayerMain
      );
      core.setLocalStorageValue(config.formationId, jFormation);
      core.setLocalStorageValue(
        config.tempSelectedPlayerCookieName,
        JSON.stringify(arrSelectedPlayerMain)
      );
      return {
        ...state,
        arrSelectedPlayer: arrSelectedPlayerMain,
        jSkillFiltreTab: objTab.jSkillFiltreTab,
        jSkillFiltreTabPlayer: objTab.jSkillFiltreTabPlayer,
      };
    }
    case ADD_REMOVED_PLAYER_FROM_FORMATION: {
      return {
        ...state,
        jAvoidFiltreIndex: action.payload,
      };
    }
    case REMOVE_REMOVED_PLAYER_FROM_FORMATION: {
      return {
        ...state,
        jAvoidFiltreIndex: config.emptyValue,
      };
    }
    case ADD_PLAYER_FOR_CARD: {
      return {
        ...state,
        objPlayerCardFiltreIndex: action.payload,
      };
    }
    case REMOVE_PLAYER_FOR_CARD: {
      return {
        ...state,
        objPlayerCardFiltreIndex: null,
      };
    }
    case SHOW_HIDE_OVERLAY: {
      return {
        ...state,
        objOverlay: { ...state.objOverlay, ...action.payload },
      };
    }
    case CHANGE_PLAYER_CARD_TAB: {
      const { jPlayerCardTab } = action.payload;
      let jPlayerCardTabT = jPlayerCardTab;
      return {
        ...state,
        jPlayerCardTab: jPlayerCardTabT,
      };
    }
    case FETCH_PLAYER_STATS_PENDING: {
      return {
        ...state,
        isPlayerStatsLoading: true,
        isPlayerStatsError: false,
        isPlayerStatsSuccess: false,
      };
    }
    case FETCH_PLAYER_STATS_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPlayerStatsError: true,
        isPlayerStatsLoading: false,
        isPlayerStatsSuccess: false,
      };
    }
    case FETCH_PLAYER_STATS_FULFILLED: {
      let playerStats = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        playerStats = action.payload.data.Data.Value;
      }
      return {
        ...state,
        isPlayerStatsError: false,
        isPlayerStatsLoading: false,
        isPlayerStatsSuccess: true,
        objPlayerStats: playerStats,
      };
    }
    case SELECT_C_VC: {
      const { isCaptain, Id, isImpactPlayer } = action.payload;
      const { hasTeam, arrSelectedPlayer } = state;
      let arrSelectedPlayerT = [];
      for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
        const objPlayer = arrSelectedPlayer[j];
        if (objPlayer.Id === Id) {
          if (isCaptain) {
            arrSelectedPlayerT.push({
              ...objPlayer,
              isCaptain: true,
              isViceCaptain: false,
              isImpactPlayer: false,
            });
          } else if (isImpactPlayer) {
            arrSelectedPlayerT.push({
              ...objPlayer,
              isCaptain: false,
              isViceCaptain: false,
              isImpactPlayer: true,
            });
          } else {
            arrSelectedPlayerT.push({
              ...objPlayer,
              isCaptain: false,
              isViceCaptain: true,
              isImpactPlayer: false,
            });
          }
        } else {
          if (isCaptain) {
            arrSelectedPlayerT.push({ ...objPlayer, isCaptain: false });
          } else if (isImpactPlayer) {
            arrSelectedPlayerT.push({ ...objPlayer, isImpactPlayer: false });
          } else {
            arrSelectedPlayerT.push({ ...objPlayer, isViceCaptain: false });
          }
        }
      }
      if (!hasTeam) {
        core.setLocalStorageValue(
          config.tempSelectedPlayerCookieName,
          JSON.stringify(arrSelectedPlayerT)
        );
      }
      return {
        ...state,
        arrSelectedPlayer: arrSelectedPlayerT,
      };
    }
    case CHANGE_SORT_BY_TEAM: {
      const { jSelectedSortingColumnTeam, isLoadTime } = action.payload;
      const {
        arrSortingColumnTeam,
        jSelectedSortingColumnTeam: jSelectedSortingColumnTeamOld,
        arrSelectedPlayer,
        arrPlayers,
      } = state;
      let jSelectedSortingColumnTeamP = jSelectedSortingColumnTeam;
      let arrPlayerListingSorted = arrSelectedPlayer;
      let arrSortingColumnTeamT = [];
      let sortByDesc = false;
      for (let j = 0; j < arrSortingColumnTeam.length; j++) {
        let row = arrSortingColumnTeam[j];
        if (row.sortByDesc) {
          sortByDesc = row.sortByDesc;
        }
      }
      for (let j = 0; j < arrSortingColumnTeam.length; j++) {
        let row = arrSortingColumnTeam[j];
        if (jSelectedSortingColumnTeam === j) {
          if (jSelectedSortingColumnTeamOld !== jSelectedSortingColumnTeam) {
            if (isLoadTime) {
              sortByDesc = true;
            }
            arrSortingColumnTeamT.push({ ...row, sortByDesc: sortByDesc });
            /*arrPlayerListingSorted = arrSelectedPlayer.sort(function (a, b) {
                            const eleA = app.getPlayerDetails(arrPlayers, a.Id);
                            const eleB = app.getPlayerDetails(arrPlayers, b.Id);
                            if (eleA && eleB) {
                                let jFltrSortBy = row.sortingColumn;
                                let valueA = eleA[jFltrSortBy];
                                let valueB = eleB[jFltrSortBy];
                                valueA = valueA ? (+(valueA)) : 0;
                                valueB = valueB ? (+(valueB)) : 0;

                                if (valueA > valueB) {
                                    return -1;
                                }
                                if (valueA < valueB) {
                                    return 1;
                                }
                            }
                            return 0;
                        });*/
          } else {
            if (!isLoadTime) {
              sortByDesc = !row.sortByDesc;
            } else {
              sortByDesc = true;
            }
            arrSortingColumnTeamT.push({ ...row, sortByDesc: sortByDesc });
          }
          arrPlayerListingSorted =
            arrSelectedPlayer &&
            arrSelectedPlayer.sort(function (a, b) {
              const eleA = app.getPlayerDetails(arrPlayers, a.Id);
              const eleB = app.getPlayerDetails(arrPlayers, b.Id);
              if (eleA && eleB) {
                let jFltrSortBy = row.sortingColumn;
                let valueA = eleA[jFltrSortBy];
                let valueB = eleB[jFltrSortBy];

                if (!isNaN(valueA)) {
                  valueA = valueA ? +valueA : 0;
                  valueB = valueB ? +valueB : 0;
                }
                if (sortByDesc) {
                  if (valueA > valueB) {
                    return -1;
                  }
                  if (valueA < valueB) {
                    return 1;
                  }
                } else {
                  if (valueA > valueB) {
                    return 1;
                  }
                  if (valueA < valueB) {
                    return -1;
                  }
                }
              }
              return 0;
            });
        } else {
          arrSortingColumnTeamT.push({ ...row, sortByDesc: false });
        }
      }
      return {
        ...state,
        jSelectedSortingColumnTeam: jSelectedSortingColumnTeamP,
        arrSortingColumnTeam: arrSortingColumnTeamT,
        arrSelectedPlayer: arrPlayerListingSorted,
      };
    }

    case FETCH_PUBLIC_CONTEST_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPublicContestLoading: true,
        isPublicContestError: false,
        isPublicContestSuccess: false,
      };
    }
    case FETCH_PUBLIC_CONTEST_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPublicContestLoading: false,
        isPublicContestError: true,
        isPublicContestSuccess: false,
      };
    }
    case FETCH_PUBLIC_CONTEST_FULFILLED: {
      let contestList = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        contestList = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }

      return {
        ...state,
        jErrorcode: jErrorcode,
        isPublicContestLoading: false,
        isPublicContestError: false,
        isPublicContestSuccess: true,
        publicContestList: contestList,
      };
    }

    case FETCH_PRIVATE_CONTEST_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPrivateContestLoading: true,
        isPrivateContestError: false,
        isPrivateContestSuccess: false,
      };
    }
    case FETCH_PRIVATE_CONTEST_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPrivateContestLoading: false,
        isPrivateContestError: true,
        isPrivateContestSuccess: false,
      };
    }
    case FETCH_PRIVATE_CONTEST_FULFILLED: {
      let contestList = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        contestList = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPrivateContestLoading: false,
        isPrivateContestError: false,
        isPrivateContestSuccess: true,
        privateContestList: contestList,
      };
    }

    case POST_CREATE_CONTEST_PENDING: {
      return {
        ...state,
        isCretContestLoading: true,
        isCretContestError: false,
        isCretContestSuccess: false,
      };
    }
    case POST_CREATE_CONTEST_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCretContestLoading: false,
        isCretContestError: true,
        isCretContestSuccess: false,
      };
    }
    case POST_CREATE_CONTEST_FULFILLED: {
      let contestRes = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        contestRes = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCretContestLoading: false,
        isCretContestError: false,
        isCretContestSuccess: true,
        cretContestRes: contestRes,
      };
    }

    case POST_JOIN_CONTEST_PENDING: {
      return {
        ...state,
        isJoinContestLoading: true,
        isJoinContestError: false,
        isJoinContestSuccess: false,
      };
    }
    case POST_JOIN_CONTEST_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isJoinContestLoading: false,
        isJoinContestError: true,
        isJoinContestSuccess: false,
      };
    }
    case POST_JOIN_CONTEST_FULFILLED: {
      let contestRes = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        contestRes = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isJoinContestLoading: false,
        isJoinContestError: false,
        isJoinContestSuccess: true,
        joinContestRes: contestRes,
      };
    }

    case FETCH_CONTEST_LEADERBOARD_PENDING: {
      return {
        ...state,
        isContestLeaderboardLoading: true,
        isContestLeaderboardError: false,
        isContestLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_CONTEST_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isContestLeaderboardLoading: false,
        isContestLeaderboardError: true,
        isContestLeaderboardSuccess: false,
      };
    }
    case FETCH_CONTEST_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          isLive &&
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isContestLeaderboardLoading: false,
        isContestLeaderboardError: false,
        isContestLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_GLOBAL_LEADERBOARD_PENDING: {
      return {
        ...state,
        isGlobalLeaderboardLoading: true,
        isGlobalLeaderboardError: false,
        isGlobalLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_GLOBAL_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGlobalLeaderboardLoading: false,
        isGlobalLeaderboardError: true,
        isGlobalLeaderboardSuccess: false,
      };
    }
    case FETCH_GLOBAL_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        !isLive &&
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }
      return {
        ...state,
        isGlobalLeaderboardLoading: false,
        isGlobalLeaderboardError: false,
        isGlobalLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_GLOBAL_LIVE_RANK_PENDING: {
      return {
        ...state,
        isGlobalLeaderboardRankLoading: true,
        isGlobalLeaderboardRankError: false,
        isGlobalLeaderboardRankSuccess: false,
      };
    }
    case FETCH_GLOBAL_LIVE_RANK_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGlobalLeaderboardRankLoading: false,
        isGlobalLeaderboardRankError: true,
        isGlobalLeaderboardRankSuccess: false,
      };
    }
    case FETCH_GLOBAL_LIVE_RANK_FULFILLED: {
      let contestMyRankRes = state.contestLeaderboardMyRes;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (data && data.length) {
          if (data && data[0] && data[0].legid) {
            // leaderboard structure for self rank from rank api
            let myRank = app.processUserRankDataManipulation(data[0]);
            contestMyRankRes = [myRank];
          }
        }
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGlobalLeaderboardRankLoading: false,
        isGlobalLeaderboardRankError: false,
        isGlobalLeaderboardRankSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
      };
    }

    case FETCH_FAVTEAM_LEADERBOARD_PENDING: {
      return {
        ...state,
        isFavTeamLeaderboardLoading: true,
        isFavTeamLeaderboardError: false,
        isFavTeamLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_FAVTEAM_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFavTeamLeaderboardLoading: false,
        isFavTeamLeaderboardError: true,
        isFavTeamLeaderboardSuccess: false,
      };
    }
    case FETCH_FAVTEAM_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        !isLive &&
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }
      return {
        ...state,
        isFavTeamLeaderboardLoading: false,
        isFavTeamLeaderboardError: false,
        isFavTeamLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_FAVTEAM_LIVE_RANK_PENDING: {
      return {
        ...state,
        isFavTeamLeaderboardRankLoading: true,
        isFavTeamLeaderboardRankError: false,
        isFavTeamLeaderboardRankSuccess: false,
      };
    }
    case FETCH_FAVTEAM_LIVE_RANK_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFavTeamLeaderboardRankLoading: false,
        isFavTeamLeaderboardRankError: true,
        isFavTeamLeaderboardRankSuccess: false,
      };
    }
    case FETCH_FAVTEAM_LIVE_RANK_FULFILLED: {
      let contestMyRankRes = state.contestLeaderboardMyRes;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (data && data.length) {
          if (data && data[0] && data[0].legid) {
            // leaderboard structure for self rank from rank api
            let myRank = app.processUserRankDataManipulation(data[0]);
            contestMyRankRes = [myRank];
          }
        }
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFavTeamLeaderboardRankLoading: false,
        isFavTeamLeaderboardRankError: false,
        isFavTeamLeaderboardRankSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
      };
    }

    case FETCH_CAPTAIN_LEADERBOARD_PENDING: {
      return {
        ...state,
        isCaptainLeaderboardLoading: true,
        isCaptainLeaderboardError: false,
        isCaptainLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_CAPTAIN_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCaptainLeaderboardLoading: false,
        isCaptainLeaderboardError: true,
        isCaptainLeaderboardSuccess: false,
      };
    }
    case FETCH_CAPTAIN_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        !isLive &&
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }
      return {
        ...state,
        isCaptainLeaderboardLoading: false,
        isCaptainLeaderboardError: false,
        isCaptainLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_CAPTAIN_LIVE_RANK_PENDING: {
      return {
        ...state,
        isCaptainLeaderboardRankLoading: true,
        isCaptainLeaderboardRankError: false,
        isCaptainLeaderboardRankSuccess: false,
      };
    }
    case FETCH_CAPTAIN_LIVE_RANK_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCaptainLeaderboardRankLoading: false,
        isCaptainLeaderboardRankError: true,
        isCaptainLeaderboardRankSuccess: false,
      };
    }
    case FETCH_CAPTAIN_LIVE_RANK_FULFILLED: {
      let contestMyRankRes = state.contestLeaderboardMyRes;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (data && data.length) {
          if (data && data[0] && data[0].legid) {
            // leaderboard structure for self rank from rank api
            let myRank = app.processUserRankDataManipulation(data[0]);
            contestMyRankRes = [myRank];
          }
        }
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isCaptainLeaderboardRankLoading: false,
        isCaptainLeaderboardRankError: false,
        isCaptainLeaderboardRankSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
      };
    }

    case FETCH_VICE_CAPTAIN_LEADERBOARD_PENDING: {
      return {
        ...state,
        isViceCaptainLeaderboardLoading: true,
        isViceCaptainLeaderboardError: false,
        isViceCaptainLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_VICE_CAPTAIN_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isViceCaptainLeaderboardLoading: false,
        isViceCaptainLeaderboardError: true,
        isViceCaptainLeaderboardSuccess: false,
      };
    }
    case FETCH_VICE_CAPTAIN_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        !isLive &&
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }
      return {
        ...state,
        isViceCaptainLeaderboardLoading: false,
        isViceCaptainLeaderboardError: false,
        isViceCaptainLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_VICE_CAPTAIN_LIVE_RANK_PENDING: {
      return {
        ...state,
        isViceCaptainLeaderboardRankLoading: true,
        isViceCaptainLeaderboardRankError: false,
        isViceCaptainLeaderboardRankSuccess: false,
      };
    }
    case FETCH_VICE_CAPTAIN_LIVE_RANK_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isViceCaptainLeaderboardRankLoading: false,
        isViceCaptainLeaderboardRankError: true,
        isViceCaptainLeaderboardRankSuccess: false,
      };
    }
    case FETCH_VICE_CAPTAIN_LIVE_RANK_FULFILLED: {
      let contestMyRankRes = state.contestLeaderboardMyRes;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (data && data.length) {
          if (data && data[0] && data[0].legid) {
            // leaderboard structure for self rank from rank api
            let myRank = app.processUserRankDataManipulation(data[0]);
            contestMyRankRes = [myRank];
          }
        }
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isViceCaptainLeaderboardRankLoading: false,
        isViceCaptainLeaderboardRankError: false,
        isViceCaptainLeaderboardRankSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
      };
    }

    case FETCH_KNOCKOUT_LEADERBOARD_PENDING: {
      return {
        ...state,
        isKnockoutLeaderboardLoading: true,
        isKnockoutLeaderboardError: false,
        isKnockoutLeaderboardSuccess: false,
        // //newly added
        // contestLeaderboardMyRes: [],
        // contestLeaderboardRes: [],
      };
    }
    case FETCH_KNOCKOUT_LEADERBOARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isKnockoutLeaderboardLoading: false,
        isKnockoutLeaderboardError: true,
        isKnockoutLeaderboardSuccess: false,
      };
    }
    case FETCH_KNOCKOUT_LEADERBOARD_FULFILLED: {
      let contestRes = state.contestLeaderboardRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      let isLive = action.meta && action.meta.isLive;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        !isLive &&
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(data, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }

        let processedData = app.processLeaderboardData(
          state.contestLeaderboardRes,
          data
        );
        contestRes = processedData;
      }
      return {
        ...state,
        isKnockoutLeaderboardLoading: false,
        isKnockoutLeaderboardError: false,
        isKnockoutLeaderboardSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestLeaderboardRes: contestRes,
      };
    }

    case FETCH_KNOCKOUT_LIVE_RANK_PENDING: {
      return {
        ...state,
        isKnockoutLeaderboardRankLoading: true,
        isKnockoutLeaderboardRankError: false,
        isKnockoutLeaderboardRankSuccess: false,
      };
    }
    case FETCH_KNOCKOUT_LIVE_RANK_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isKnockoutLeaderboardRankLoading: false,
        isKnockoutLeaderboardRankError: true,
        isKnockoutLeaderboardRankSuccess: false,
      };
    }
    case FETCH_KNOCKOUT_LIVE_RANK_FULFILLED: {
      let contestMyRankRes = state.contestLeaderboardMyRes;
      let lObj = action.meta && action.meta.leagueObj;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let data = action.payload.data.Data.Value;

        if (data && data.length) {
          if (data && data[0] && data[0].legid) {
            // leaderboard structure for self rank from rank api
            let myRank = app.processUserRankDataManipulation(data[0]);
            contestMyRankRes = [myRank];
          }
        }
      }

      if (
        lObj &&
        lObj.legid &&
        !(contestMyRankRes && contestMyRankRes.length)
      ) {
        // leaderboard structure for self rank from contest listing api
        let myRank = app.processUserRankDataManipulation(lObj);
        contestMyRankRes.push(myRank);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isKnockoutLeaderboardRankLoading: false,
        isKnockoutLeaderboardRankError: false,
        isKnockoutLeaderboardRankSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
      };
    }

    case FETCH_CONTEST_NEWJOINEE_PENDING: {
      return {
        ...state,
        isContestNewJoineeLoading: true,
        isContestNewJoineeError: false,
        isContestNewJoineeSuccess: false,
      };
    }
    case FETCH_CONTEST_NEWJOINEE_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isContestNewJoineeLoading: false,
        isContestNewJoineeError: true,
        isContestNewJoineeSuccess: false,
      };
    }
    case FETCH_CONTEST_NEWJOINEE_FULFILLED: {
      let contestRes = state.contestNewJoineeRes,
        contestMyRankRes = state.contestLeaderboardMyRes;
      let obj = action.meta && action.meta.cookie;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        contestRes = action.payload.data.Data.Value;
        if (
          obj &&
          obj.SocialId &&
          !(contestMyRankRes && contestMyRankRes.length)
        ) {
          // find self rank from leaderboards
          let selfRank = find(contestRes, (l) => {
            return l.usrscoid == obj.SocialId;
          });
          if (selfRank) {
            contestMyRankRes.push(selfRank);
          }
        }
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isContestNewJoineeLoading: false,
        isContestNewJoineeError: false,
        isContestNewJoineeSuccess: true,
        contestLeaderboardMyRes: contestMyRankRes,
        contestNewJoineeRes: contestRes,
      };
    }

    case FETCH_TEAM_COMPARISON_PENDING: {
      return {
        ...state,
        isTeamComparisonLoading: true,
        isTeamComparisonError: false,
        isTeamComparisonSuccess: false,
      };
    }
    case FETCH_TEAM_COMPARISON_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTeamComparisonLoading: false,
        isTeamComparisonError: true,
        isTeamComparisonSuccess: false,
      };
    }
    case FETCH_TEAM_COMPARISON_FULFILLED: {
      let comparisonRes = [];
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        comparisonRes = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTeamComparisonLoading: false,
        isTeamComparisonError: false,
        isTeamComparisonSuccess: true,
        teamComparisonData: comparisonRes,
      };
    }

    case SET_LAST_UPDATED_TIME: {
      let time = action.meta && action.meta.timespan;
      return {
        ...state,
        leaderboardLastUpdated: time,
      };
    }

    case RESET_CONTEST_LEADERBOARD_DATA: {
      return {
        ...state,
        isContestLeaderboardLoading: false,
        isContestLeaderboardError: false,
        isContestLeaderboardSuccess: false,
        contestLeaderboardMyRes: [],
        contestLeaderboardRes: [],
        contestNewJoineeRes: [],
        leaderboardLastUpdated: null,
      };
    }

    case CHANGE_SELECTED_FIXTURE: {
      let isSelectedFixtureT = true;
      const { arrFixtures, jFixtures, hasTeam, jAutorefreshSelectedFixture } =
        state;
      const { jStatus, isSelectedFixture, isAvoidLiveUrls } = action.payload;
      let jFixturesT = jFixtures;
      isSelectedFixtureT = isSelectedFixture;
      let jAutorefreshSelectedFixtureT = jAutorefreshSelectedFixture;
      if (isSelectedFixture) {
        jFixturesT = -1;
        for (let j = 0; j < (arrFixtures || []).length; j++) {
          let obj = arrFixtures[j];
          const jMdStatus = app.getFixtureStatusByRow(obj);
          if (jMdStatus === jStatus) {
            jFixturesT = j;
            break;
          }
        }
        if (jFixturesT === -1) {
          for (let j = 0; j < (arrFixtures || []).length; j++) {
            let obj = arrFixtures[j];
            const jMdStatus = app.getFixtureStatusByRow(obj);
            if (
              jMdStatus === config.enumFixtureType.isLock ||
              jMdStatus === config.enumFixtureType.isEnded ||
              jMdStatus === config.enumFixtureType.isFinished ||
              jMdStatus === config.enumFixtureType.isAbandoned ||
              jMdStatus === config.enumFixtureType.isPostMatchAbandoned
            ) {
              jFixturesT = j;
              //break;
            }
          }
        }
        jAutorefreshSelectedFixtureT = jAutorefreshSelectedFixtureT + 1;
        //makeLive(arrFixtures, hasTeam, isAvoidLiveUrls);
      }

      return {
        ...state,
        isSelectedFixture: isSelectedFixtureT,
        jFixtures: jFixturesT,
        jAutorefreshSelectedFixture: jAutorefreshSelectedFixtureT,
      };
    }

    case FETCH_TRANSFER_HISTORY_PENDING: {
      return {
        ...state,
        isTransferHistoryError: false,
        isTransferHistoryLoading: true,
        isTransferHistorySuccess: false,
      };
    }

    case FETCH_TRANSFER_HISTORY_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferHistoryError: true,
        isTransferHistoryLoading: false,
        isTransferHistorySuccess: false,
      };
    }

    case FETCH_TRANSFER_HISTORY_FULFILLED: {
      let transferHistory = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        transferHistory = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferHistoryError: false,
        isTransferHistoryLoading: false,
        isTransferHistorySuccess: true,
        transferHistory: transferHistory,
      };
    }

    case FETCH_TRANSFER_HISTORY_PLAYERS_PENDING: {
      return {
        ...state,
        isTransferHistoryPlayersError: false,
        isTransferHistoryPlayersLoading: true,
        isTransferHistoryPlayersSuccess: false,
        transferHistoryPlayers: null,
      };
    }

    case FETCH_TRANSFER_HISTORY_PLAYERS_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferHistoryPlayersError: true,
        isTransferHistoryPlayersLoading: false,
        isTransferHistoryPlayersSuccess: false,
      };
    }

    case FETCH_TRANSFER_HISTORY_PLAYERS_FULFILLED: {
      let transferHistoryPlayers = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        transferHistoryPlayers = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTransferHistoryPlayersError: false,
        isTransferHistoryPlayersLoading: false,
        isTransferHistoryPlayersSuccess: true,
        transferHistoryPlayers: transferHistoryPlayers,
      };
    }

    // case RESET_TEAM: {
    //   let arrSelectedPlayerDefaultS = state.arrSelectedPlayerDefault;
    //   let arrSelectedPlayerDefault = [];
    //   core.deepCopy(arrSelectedPlayerDefault, arrSelectedPlayerDefaultS);

    //   // const objFixture = app.getSelectedFixture(
    //   //   state.arrFixtures,
    //   //   state.jFixtures
    //   // );
    //   // if (objFixture.Gameday !== state.objUserTeam.gdid) {
    //   //   prevTeam = state.objUserTeam?.prplyid;
    //   // } else {
    //   //   prevTeam = state.objUserTeam?.plyid;
    //   // }
    //   // prevTeam = state.arrPlayers.filter((pl) => {
    //   //   return prevTeam?.includes(pl.Id);
    //   // if (prevTeam?.includes(pl.Id)) {
    //   //   return { Id: pl.Id, TeamId: pl.TeamId };
    //   // } else {
    //   //   return null;
    //   // }
    //   // });
    //   // .filter((pl) => pl !== null) || [];

    //   let prevTeam = state.userTeamData
    //     ?.map((id) => state.arrPlayers.find((pl) => pl.Id == id))
    //     .filter(Boolean); // Ensures only valid player objects are included

    //   return {
    //     ...state,
    //     arrSelectedPlayer: arrSelectedPlayerDefault,
    //     currUserTeam: prevTeam,
    //   };
    // }

    case RESET_TEAM: {
      let arrSelectedPlayerDefaultS = state.arrSelectedPlayerDefault;
      let arrSelectedPlayerDefault = [];
      core.deepCopy(arrSelectedPlayerDefault, arrSelectedPlayerDefaultS);

      const objFixture = app.getSelectedFixture(
        state.arrFixtures,
        state.jFixtures
      );

      // let prevTeam = state.arrUserTeam.map((ply) => ply.Id);
      let prevTeam = state.prevUserTeam || [];
      // if (objFixture.Gameday != state.objUserTeam.gdid) {
      //   // prevTeam = state.objUserTeam?.plyid;
      //   prevTeam = state.arrUserTeam.map((ply) => ply.Id);
      // } else {
      //   prevTeam = state.objUserTeam?.prplyid;
      // }

      // prevTeam = prevTeam
      //   ?.map((id) => state.arrPlayers.find((pl) => pl.Id == id))
      //   .filter(Boolean); // Ensures only valid player objects are included

      return {
        ...state,
        arrSelectedPlayer: arrSelectedPlayerDefault,
        currUserTeam: prevTeam,
      };
    }
    case FETCH_PLAYERS_STATS_PENDING: {
      return {
        ...state,
        isPlayerStatisticsLoading: true,
        isPlayerStatisticsError: false,
        isPlayerStatisticsSuccess: false,
      };
    }

    case FETCH_PLAYERS_STATS_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isPlayerStatisticsLoading: false,
        isPlayerStatisticsError: true,
        isPlayerStatisticsSuccess: false,
      };
    }
    // TODO: FIx dual LISTING
    case FETCH_PLAYERS_STATS_FULFILLED: {
      let groupedStats = [],
        sortedPlayers = [],
        matchDayGroup = [],
        arrContestFilterTabT = [];
      let isShowPlayerStats = false;
      const { Data } = action.payload.data;
      const { arrFixtures } = state;
      const arrResultFixtures = arrFixtures.map((ele, jIndex) => {
        if (Number(ele.IsActiveForNewUser)) {
          ele.IsCurrent = 1;
        }
        if (ele.MatchdateTime && ele.MatchdateTime.indexOf("GMT") === -1) {
          ele.MatchdateTime = `${ele.MatchdateTime} GMT`;
        }
        const jMdStatus = app.getFixtureStatusByRow(ele);
        if (
          jMdStatus == config.enumFixtureType.isLock ||
          jMdStatus == config.enumFixtureType.isFinished ||
          jMdStatus == config.enumFixtureType.isEnded ||
          jMdStatus == config.enumFixtureType.isAbandoned ||
          jMdStatus == config.enumFixtureType.isPostponed
        ) {
          isShowPlayerStats = true;
        }
        if (ele.Venue1) {
          const sVenue2 = ele.Venue1;
          let sVenue3 = `${sVenue2}`;
          sVenue3 = sVenue3.replace("International Sportspark", "ISP");
          sVenue3 = sVenue3.replace("Bellerive Oval", "Blundstone Arena");
          sVenue3 = sVenue3.replace(
            "Brisbane Cricket Ground (Woolloongabba)",
            "The Gabba"
          );
          sVenue3 = sVenue3.replace(
            "Aurora Stadium",
            "University of Tasmania Stadium"
          );
          sVenue3 = sVenue3.replace("Carrara Oval", "Metricon Stadium");
          sVenue3 = sVenue3.replace("Perth Stadium", "Optus Stadium");
          sVenue3 = sVenue3.replace("Docklands Stadium", "Marvel Stadium");
          ele.Venue1 = sVenue3;
        }
        return { ...ele };
      });

      if (Data) {
        const { Value } = Data;
        const { PlayerStats, GamedayIds } = Value;
        const { arrContestFilterTab, trans } = state;
        if (PlayerStats && GamedayIds) {
          for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
            const objRow = arrContestFilterTab[j];
            //FIXME: changed revert if true
            // let arrDetails = objRow.arrDetails;
            let arrDetails = [];
            if (objRow.id === config.enumTabsId.matches) {
              for (let jN = 0; jN < (arrResultFixtures || []).length; jN++) {
                const objFixture = arrResultFixtures[jN];
                let jStatus = app.getFixtureStatusByRow(objFixture);
                const jIndex = core.getIndexOfArrayByValue(
                  arrDetails,
                  "id",
                  objFixture.MatchId
                );
                if (jIndex === -1) {
                  const sLabel = `${objFixture.HomeTeamShortName} ${
                    trans && trans.vs ? trans.vs : "vs"
                  } ${objFixture.AwayTeamShortName}`;
                  //Changed Date
                  const gmtMatchdateTime = core.convertTimeToOffset(
                    objFixture.MatchdateTime,
                    config.offSetToAdd
                  );
                  const sDesc = `${objFixture.MatchNumber}, ${core.dateFormat(
                    gmtMatchdateTime,
                    "mmm d, h:MM TT"
                  )}${config.offSetText}`;
                  if (
                    objFixture.HomeTeamId &&
                    objFixture.AwayTeamId &&
                    (jStatus === config.enumFixtureType.isOpen ||
                      jStatus === config.enumFixtureType.isUpcomming)
                  ) {
                    arrDetails.push({
                      id: objFixture.MatchId,
                      value: sLabel,
                      checked: false,
                      defaultChecked: false,
                      tempChecked: false,
                      desc: sDesc,
                    });
                  }
                }
              }
            } else if (objRow.id === config.enumTabsId.teams) {
              for (let jN = 0; jN < (PlayerStats || []).length; jN++) {
                if (arrDetails.length >= 1) {
                  arrDetails = arrDetails.sort((a, b) => {
                    if (a.value < b.value) {
                      return -1;
                    }
                    if (a.value > b.value) {
                      return 1;
                    }
                  });
                }
                const objPlayer = PlayerStats[jN];
                const jIndex = core.getIndexOfArrayByValue(
                  arrDetails,
                  "id",
                  objPlayer.teamid
                );
                if (jIndex === -1) {
                  arrDetails.push({
                    id: objPlayer.teamid,
                    value: objPlayer.tmnm,
                    checked: false,
                    defaultChecked: false,
                    tempChecked: false,
                  });
                }
              }
            } else if (objRow.id === config.enumTabsId.skill) {
              arrDetails.push({
                id: config.enumPosition.wk,
                value: `${
                  trans && trans.wicketKeeper
                    ? trans.wicketKeeper
                    : "Wicket-Keeper"
                }`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
              arrDetails.push({
                id: config.enumPosition.bat,
                value: `${trans && trans.batsmen ? trans.batsmen : "Batters"}`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
              arrDetails.push({
                id: config.enumPosition.ar,
                value: `${
                  trans && trans.allRounder ? trans.allRounder : "All-Rounder"
                }`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
              arrDetails.push({
                id: config.enumPosition.bowl,
                value: `${trans && trans.bowler ? trans.bowler : "Bowler"}`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
            } else if (objRow.id === config.enumTabsId.nationality) {
              arrDetails.push({
                id: config.enumNationalityIds.indian,
                value: `${trans && trans.indian ? trans.indian : "Indian"}`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
              arrDetails.push({
                id: config.enumNationalityIds.foreign,
                value: `${trans && trans.foreign ? trans.foreign : "Overseas"}`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
            } else if (objRow.id === config.enumTabsId.uncap) {
              arrDetails.push({
                id: config.enumCapFilterIds.cap,
                value: `${
                  trans && trans.capPlayer ? trans.capPlayer : "Capped Player"
                }`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
              arrDetails.push({
                id: config.enumCapFilterIds.uncap,
                value: `${
                  trans && trans.uncapPlayer
                    ? trans.uncapPlayer
                    : "Uncapped Player"
                }`,
                checked: false,
                defaultChecked: false,
                tempChecked: false,
              });
            } else if (objRow.id === config.enumTabsId.creditRange) {
              arrDetails.push({
                id: 1,
                value:
                  trans && trans.creditRange1
                    ? trans.creditRange1
                    : "Less than 7",
                checked: false,
                defaultChecked: false,
                tempChecked: false,
                min: -1,
                max: 7,
              });
              arrDetails.push({
                id: 2,
                value:
                  trans && trans.creditRange2 ? trans.creditRange2 : "7 - 9",
                checked: false,
                defaultChecked: false,
                tempChecked: false,
                min: 7,
                max: 9,
              });
              arrDetails.push({
                id: 3,
                value:
                  trans && trans.creditRange3
                    ? trans.creditRange3
                    : "More than 9",
                checked: false,
                defaultChecked: false,
                tempChecked: false,
                min: 9,
                max: -1,
              });
              // arrDetails.push({
              //   id: 4,
              //   value:
              //     trans && trans.creditRange4 ? trans.creditRange4 : "10.5-12",
              //   checked: false,
              //   defaultChecked: false,
              //   tempChecked: false,
              //   min: 10.5,
              //   max: -1,
              // });
              // arrDetails.push({
              //   id: 5,
              //   value:
              //     trans && trans.creditRange5
              //       ? trans.creditRange5
              //       : "12.5 and above",
              //   checked: false,
              //   defaultChecked: false,
              //   tempChecked: false,
              //   min: 12.5,
              //   max: -1,
              // });

              // TODO: add options
            }

            arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetails });
          }

          sortedPlayers = PlayerStats.sort((a, b) => b.ovrpoint - a.ovrpoint);
          groupedStats = GamedayIds.map((gid) => {
            return sortedPlayers.map((player, index) => {
              const {
                pstats,
                plyrid,
                teamid,
                ovrpoint,
                isfp,
                isuncap,
                isusrplyr,
                isinjd,
                plyrnm,
                value,
                desc,
                isanned,
                tmnm,
                tmshrtnm,
                sklid,
                sklnm,
                sklshrtnm,
              } = player;
              let filteredStats = null;
              if (pstats) {
                filteredStats = { ...pstats.filter((gdid) => gdid.gid == gid) };
                filteredStats = filteredStats[0];
              }
              return {
                playerId: plyrid,
                TeamId: teamid,
                OverallPoints: ovrpoint,
                isfp: isfp,
                isuncap: isuncap,
                isusrplyr: isusrplyr,
                isinjd: isinjd,
                plyrnm: plyrnm,
                value: value,
                desc: desc,
                isanned: isanned,
                tmnm: tmnm,
                tmshrtnm: tmshrtnm,
                sklid: sklid,
                sklnm: sklnm,
                sklshrtnm: sklshrtnm,
                filteredStats: filteredStats,
                gdid:
                  filteredStats && filteredStats.gid ? filteredStats.gid : "-",
                sper:
                  filteredStats && filteredStats.sper
                    ? `${filteredStats.sper}%`
                    : "-",
                gdpoint:
                  filteredStats && filteredStats.gdpoint
                    ? filteredStats.gdpoint
                    : "-",
                csper:
                  filteredStats && filteredStats.csper
                    ? `${filteredStats.csper}%`
                    : "-",
                vcsper:
                  filteredStats && filteredStats.vcsper
                    ? `${filteredStats.vcsper}%`
                    : "-",
              };
            });
          });
        }
      }
      for (let i = groupedStats.length; i > 0; i--) {
        if (groupedStats[i - 1].length) {
          matchDayGroup.push({
            gdid: +groupedStats[i - 1][0].gdid,
            groupedStats: groupedStats[i - 1],
          });
        }
      }
      return {
        ...state,
        isPlayerStatisticsLoading: false,
        isPlayerStatisticsError: false,
        isPlayerStatisticsSuccess: true,
        sortedPlayers: sortedPlayers,
        matchDayGroup: matchDayGroup,
        arrContestFilterTab: arrContestFilterTabT,
      };
    }

    case CONTEST_APPLY_FILTER: {
      const {
        arrContestFilterTab,
        jSkillFiltreTab,
        /* arrSkillFiltreTab, */
        arrPlayers,
        arrFixtures,
      } = state;
      let jSkillFiltreTabP = jSkillFiltreTab;
      //   const objSkillTab = app.getSelectedPosition(
      //     arrSkillFiltreTab,
      //     jSkillFiltreTabP
      //   );
      //   const jSkill = objSkillTab ? objSkillTab.SkillId : 0;
      let arrContestFilterTabT = [];
      for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
        const objRow = arrContestFilterTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          arrDetails[jN] = {
            ...arrDetails[jN],
            checked:
              arrDetails[jN]
                .tempChecked /*tempChecked: arrDetails[jN].defaultChecked*/,
          };
        }
        arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      /*//
            let fFound = false;
            for (let j = 0; j < arrPlayers.length; j++) {
                const ele = arrPlayers[j];
                if (jSkill === ele.SkillId) {
                    fFound = app.isFoundPlayerFromFilter(arrContestFilterTabT, ele, arrFixtures);
                }
            }
            if (!fFound) {
                loop1: for (let jN = 0; jN < arrSkillFiltreTab.length; jN++) {
                    const objSkillFiltreTab = arrSkillFiltreTab[jN];
                    for (let j = 0; j < arrPlayers.length; j++) {
                        const ele = arrPlayers[j];
                        if (objSkillFiltreTab.SkillId === ele.SkillId) {
                            fFound = app.isFoundPlayerFromFilter(arrContestFilterTabT, ele, arrFixtures);
                            if (fFound) {
                                jSkillFiltreTabP = jN;
                                break loop1;
                            }
                        }
                    }
                }

            }
            //*/
      return {
        ...state,
        arrContestFilterTab: arrContestFilterTabT,
        jSkillFiltreTab: jSkillFiltreTabP,
      };
    }

    case CONTEST_CLOSE_FILTER: {
      const { arrContestFilterTab } = state;
      let arrContestFilterTabT = [];
      for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
        const objRow = arrContestFilterTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          if (!arrDetails[jN].checked) {
            arrDetails[jN] = {
              ...arrDetails[jN],
              tempChecked: arrDetails[jN].defaultChecked,
            };
          } else {
            arrDetails[jN] = {
              ...arrDetails[jN],
              tempChecked: arrDetails[jN].checked,
            };
          }
        }
        arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      return {
        ...state,
        arrContestFilterTab: arrContestFilterTabT,
      };
    }

    case CONTEST_RESET_FILTER: {
      const { arrContestFilterTab } = state;
      let arrContestFilterTabT = [];
      for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
        const objRow = arrContestFilterTab[j];
        let arrDetails = objRow.arrDetails;
        for (let jN = 0; jN < (arrDetails || []).length; jN++) {
          arrDetails[jN] = {
            ...arrDetails[jN],
            checked: arrDetails[jN].defaultChecked,
            tempChecked: arrDetails[jN].defaultChecked,
          };
        }
        arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetails });
      }
      return {
        ...state,
        arrContestFilterTab: arrContestFilterTabT,
      };
    }

    case CONTEST_CHANGE_FILTER_TAB_CHECKES: {
      const { jFiltresTab, jIndex, sChecked } = action.payload;
      const { arrContestFilterTab } = state;
      let arrContestFilterTabT = [];
      for (let j = 0; j < (arrContestFilterTab || []).length; j++) {
        const objRow = arrContestFilterTab[j];
        let arrDetails = objRow.arrDetails;
        let arrDetailsT = [];
        if (jFiltresTab === j) {
          for (let jN = 0; jN < (arrDetails || []).length; jN++) {
            arrDetailsT.push({ ...arrDetails[jN] });
            if (jIndex === jN) {
              arrDetailsT[jN][sChecked] = !arrDetailsT[jN][sChecked];
              //break;
            }
          }
        } else {
          arrDetailsT = arrDetails;
        }
        arrContestFilterTabT.push({ ...objRow, arrDetails: arrDetailsT });
      }
      return {
        ...state,
        arrContestFilterTab: arrContestFilterTabT,
      };
    }

    case CONTEST_CHANGE_FILTER_TAB: {
      const { jFiltresTab } = action.payload;
      let jFiltresTabP = jFiltresTab;
      return {
        ...state,
        jContestFiltresTab: jFiltresTabP,
      };
    }
    case FETCH_PLAYERS_LIVE_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLivePlayersLoading: true,
        isLivePlayersError: false,
        isLivePlayersSuccess: false,
      };
    }
    case FETCH_PLAYERS_LIVE_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isLivePlayersLoading: false,
        isLivePlayersError: true,
        isLivePlayersSuccess: false,
      };
    }
    case FETCH_PLAYERS_LIVE_FULFILLED: {
      let arrLivePlayers = null;
      const { isUpdateOriginal } = action.meta;
      const { arrPlayers } = state;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let arrPlayersT = arrPlayers;

        arrLivePlayers = action.payload.data.Data.Value.Players;
        if (isUpdateOriginal) {
          arrPlayersT = arrLivePlayers;
        }
        return {
          ...state,
          isLivePlayersLoading: false,
          isLivePlayersError: false,
          isLivePlayersSuccess: true,
          arrLivePlayers: arrLivePlayers,
          arrPlayers: arrPlayersT,
        };
      }
      return {
        ...state,
      };
    }
    case CHANGE_SELECTED_TEAM: {
      let arrUserTeam = [];
      let arrSelectedPlayerMain = [];
      const arrSelectedPlayerT = state.arrSelectedPlayer;
      let hasTeam = state.hasTeam;
      let parseJSON = action.payload;
      for (let j = 0; j < (parseJSON.plyid || []).length; j++) {
        const objId = parseJSON.plyid[j];
        const objPlayer = app.getPlayerDetails(state?.arrPlayers, objId);
        const objSkillId = objPlayer.SkillId;
        arrUserTeam.push({ Id: objId, SkillId: objSkillId });
      }
      for (let jN = 0; jN < (arrUserTeam || []).length; jN++) {
        let rowTeam = arrUserTeam[jN];
        const jPlayerId = Number(rowTeam.Id);
        const jSkill = Number(rowTeam.SkillId);
        const isCaptain = parseJSON.mcapt === jPlayerId;
        const isViceCaptain = parseJSON.vcapt === jPlayerId;
        const isImpactPlayer = parseJSON.bcapt === jPlayerId;
        arrSelectedPlayerMain.push({
          Id: jPlayerId,
          SkillId: jSkill,
          isCaptain: isCaptain,
          isViceCaptain: isViceCaptain,
          isImpactPlayer,
        });
      }
      let arrSelectedPlayerDefault = [];
      core.deepCopy(arrSelectedPlayerDefault, arrSelectedPlayerMain);
      let arrSelectedPlayer = [];
      core.deepCopy(arrSelectedPlayer, arrSelectedPlayerMain);
      //core.setLoader();

      return {
        ...state,
        arrUserTeam: arrUserTeam,
        arrSelectedPlayer: arrSelectedPlayer,
        arrSelectedPlayerDefault: arrSelectedPlayerDefault,
        objUserTeam: parseJSON,
      };
    }
    case FETCH_USER_TEAM_LIST_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isMyTeamListingLoading: true,
        isMyTeamListingError: false,
        isMyTeamListingSuccess: false,
      };
    }
    case FETCH_USER_TEAM_LIST_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMyTeamListingLoading: false,
        isMyTeamListingError: true,
        isMyTeamListingSuccess: false,
        objMyTeamListing: null,
      };
    }
    case FETCH_USER_TEAM_LIST_FULFILLED: {
      let objMyTeamListing = null;
      const { optType } = action.meta;
      let arrMyTeamListing = optType === 1 ? [] : state.arrMyTeamListing || [];
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objMyTeamListing = action.payload.data.Data.Value;
        arrMyTeamListing.push(objMyTeamListing);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMyTeamListingLoading: false,
        isMyTeamListingError: false,
        isMyTeamListingSuccess: true,
        objMyTeamListing: objMyTeamListing,
        arrMyTeamListing: arrMyTeamListing,
      };
    }
    case UPCOMING_FIXTURE: {
      const { arrFixtures, uFixture } = state;
      const { jStatus } = action.payload;
      let uFixtureT = uFixture;
      for (let j = 0; j < (arrFixtures || []).length; j++) {
        let obj = arrFixtures[j];
        let arrDetails = obj.arrDetails;
        for (let i = 0; i < (arrDetails || []).length; i++) {
          let iFixture = arrDetails[i];
          const jMdStatus = app.getFixtureStatusByRow(iFixture);
          if (jMdStatus === jStatus) {
            uFixtureT = iFixture;
            break;
          }
        }
      }
      return {
        ...state,
        uFixture: uFixtureT,
      };
    }

    case FETCH_GAMERCARD_PENDING: {
      return {
        ...state,
        isGamerCardLoading: true,
        isGamerCardError: false,
        isGamerCardSuccess: false,
      };
    }
    case FETCH_GAMERCARD_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGamerCardLoading: false,
        isGamerCardError: true,
        isGamerCardSuccess: false,
      };
    }
    case FETCH_GAMERCARD_FULFILLED: {
      let gamerCard = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        gamerCard = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isGamerCardLoading: false,
        isGamerCardError: false,
        isGamerCardSuccess: true,
        gamerCardsObj: gamerCard,
      };
    }

    case FETCH_MIX_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isMixLoading: true,
        isMixError: false,
        isMixSuccess: false,
      };
    }
    case FETCH_MIX_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isMixLoading: false,
        isMixError: true,
        isMixSuccess: false,
      };
    }
    case FETCH_MIX_FULFILLED: {
      let objMix = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objMix = action.payload.data.Data.Value;
        // objMix.IsAbandonedProcessActiveFlag =1;
        //  objMix.AbandonedGameDayId=11;
      }
      if (objMix) {
        if (
          objMix.FreezeDeadline &&
          objMix.FreezeDeadline.indexOf("GMT") === -1
        ) {
          objMix.FreezeDeadline = `${objMix.FreezeDeadline} GMT`;
        }
      }
      return {
        ...state,
        isMixLoading: false,
        isMixError: false,
        isMixSuccess: true,
        objMix: objMix,
      };
    }

    case FETCH_WIDGET_PENDING: {
      return {
        ...state,
        isWidgetLoading: true,
        isWidgetError: false,
        isWidgetSuccess: false,
      };
    }
    case FETCH_WIDGET_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isWidgetLoading: false,
        isWidgetError: true,
        isWidgetSuccess: false,
      };
    }
    case FETCH_WIDGET_FULFILLED: {
      let widgetRes = null;
      let sortedTopPlayers = null;
      let sortedTopSelectedPlayers = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        let { TopPlayers, TopSelectedPlayers } = action.payload.data.Data.Value;
        sortedTopPlayers = TopPlayers.sort(
          (a, b) => Number(b.OverallPoints) - Number(a.OverallPoints)
        );
        sortedTopSelectedPlayers = TopSelectedPlayers.sort(
          (a, b) => Number(b.SelectedPercenatge) - Number(a.SelectedPercenatge)
        );
        TopPlayers = sortedTopPlayers;
        TopSelectedPlayers = sortedTopSelectedPlayers;
        widgetRes = {
          ...action.payload.data.Data.Value,
          TopPlayers,
          TopSelectedPlayers,
        };
      }
      return {
        ...state,
        isWidgetLoading: false,
        isWidgetError: false,
        isWidgetSuccess: true,
        arrWidget: widgetRes,
      };
    }
    case IS_SHOW_MENU: {
      let flag = action.payload.flag;
      return {
        ...state,
        showMenu: flag,
      };
    }
    case IS_HEADER_DATA: {
      let data = action.payload;
      return {
        ...state,
        headersData: data,
      };
    }
    case FETCH_USER_STATS_PLAYER_PENDING: {
      return {
        ...state,
        isUserPlayerStatsLoading: true,
        isUserPlayerStatsError: false,
        isUserPlayerStatsSuccess: false,
      };
    }
    case FETCH_USER_STATS_PLAYER_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayerStatsLoading: false,
        isUserPlayerStatsError: true,
        isUserPlayerStatsSuccess: false,
      };
    }
    case FETCH_USER_STATS_PLAYER_FULFILLED: {
      let objUserPlayerStats = null;
      let arrUserPlayerStats = [];
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objUserPlayerStats = action.payload.data.Data.Value;
        arrUserPlayerStats.push(objUserPlayerStats);
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayerStatsLoading: false,
        isUserPlayerStatsError: false,
        isUserPlayerStatsSuccess: true,
        objUserPlayerStats: objUserPlayerStats,
        arrUserPlayerStats: arrUserPlayerStats,
      };
    }
    case FETCH_BOOSTERS_CONTRAINTS_PENDING: {
      return {
        ...state,
        isBoostersConstraintLoading: true,
        isBoostersConstraintError: false,
        isBoostersConstraintSuccess: false,
      };
    }
    case FETCH_BOOSTERS_CONTRAINTS_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isBoostersConstraintLoading: false,
        isBoostersConstraintError: true,
        isBoostersConstraintSuccess: false,
      };
    }
    case FETCH_BOOSTERS_CONTRAINTS_FULFILLED: {
      let arrBoostersConstraint = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrBoostersConstraint = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isBoostersConstraintLoading: false,
        isBoostersConstraintError: false,
        isBoostersConstraintSuccess: true,
        arrBoostersConstraint: arrBoostersConstraint,
      };
    }
    case CHANGE_BOOSTER: {
      const { hasTeam, arrSelectedPlayer } = state;
      let { objBooster, TeamGamedayId, isOnlyClearState } = action.payload;

      const arrSelectedPlayerMain = [];
      const jLen = (arrSelectedPlayer || []).length;
      for (let j = 0; j < jLen; j++) {
        const objPlayer = arrSelectedPlayer[j];
        arrSelectedPlayerMain.push({
          ...objPlayer,
          isImpactPlayer: false,
        });
      }
      if (!hasTeam && !isOnlyClearState) {
        core.setLocalStorageValue(
          config.tempTeamObjBooster,
          JSON.stringify(objBooster)
        );
        core.setLocalStorageValue(
          config.tempSelectedPlayerCookieName,
          JSON.stringify(arrSelectedPlayerMain)
        );
        core.setLocalStorageValue(
          config.tempTeamGamedayId,
          JSON.stringify(TeamGamedayId)
        );
      }
      return {
        ...state,
        objBooster,
        arrSelectedPlayer: arrSelectedPlayerMain,
      };
    }

    case FETCH_BADGES_PENDING: {
      return {
        ...state,
        isBadgesLoading: true,
        isBadgesError: false,
        isBadgesSuccess: false,
      };
    }
    case FETCH_BADGES_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isBadgesLoading: false,
        isBadgesError: true,
        isBadgesSuccess: false,
      };
    }
    case FETCH_BADGES_FULFILLED: {
      let arrBadges = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrBadges = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      // CHANGE HERE
      arrBadges &&
        arrBadges.map((badge) => {
          if (badge.Id === config.enumBadgeDetails[badge.Id]?.Id) {
            badge.Order = config.enumBadgeDetails[badge.Id]?.order;
          }
        });

      // console.log(temp);
      // arrBadges = groupBadges(arrBadges, "MasterId");

      return {
        ...state,
        jErrorcode: jErrorcode,
        isBadgesLoading: false,
        isBadgesError: false,
        isBadgesSuccess: true,
        arrBadges: arrBadges,
      };
    }
    case POST_REMOVE_LEAGUE_PENDING: {
      return {
        ...state,
        isRemoveLeagueLoading: true,
        isRemoveLeagueError: false,
        isRemoveLeagueSuccess: false,
      };
    }
    case POST_REMOVE_LEAGUE_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isRemoveLeagueLoading: false,
        isRemoveLeagueError: true,
        isRemoveLeagueSuccess: false,
      };
    }
    case POST_REMOVE_LEAGUE_FULFILLED: {
      let objRemoveLeague = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objRemoveLeague = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isRemoveLeagueLoading: false,
        isRemoveLeagueError: false,
        isRemoveLeagueSuccess: true,
        objRemoveLeague: objRemoveLeague,
      };
    }
    case CHANGE_REMOVE_PLAYER: {
      const { temid } = action.payload;
      const { contestLeaderboardRes, contestNewJoineeRes } = state;
      const { arrLeaderBoard: contestLeaderboardResT, isFound } =
        app.setLeaderboardByTeamId(contestLeaderboardRes, temid);
      let contestNewJoineeResT = [...contestNewJoineeRes];
      if (!isFound) {
        const { arrLeaderBoard, isFound } = app.setLeaderboardByTeamId(
          contestNewJoineeRes,
          temid
        );
        contestNewJoineeResT = arrLeaderBoard;
      }
      let remaining = contestLeaderboardRes?.filter((m) => m.temid !== temid);
      return {
        ...state,
        contestLeaderboardRes: remaining,
        contestNewJoineeRes: contestNewJoineeResT,
      };
    }
    case FETCH_USER_BADGES_PENDING: {
      return {
        ...state,
        isUserBadgesLoading: true,
        isUserBadgesError: false,
        isUserBadgesSuccess: false,
      };
    }
    case FETCH_USER_BADGES_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserBadgesLoading: false,
        isUserBadgesError: true,
        isUserBadgesSuccess: false,
      };
    }
    case FETCH_USER_BADGES_FULFILLED: {
      let arrUserBadges = { leagueBadges: null, userBadges: null };
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrUserBadges = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      //================================
      // for userBadges
      const { arrUserBadges: arrUserBadgesOld } = state;
      let sKey = "userBadges";
      let arrOld = [];
      if (arrUserBadgesOld && arrUserBadgesOld[sKey]) {
        arrOld = arrUserBadgesOld[sKey];
      }
      let arr = [];
      if (arrUserBadges && arrUserBadges[sKey]) {
        arr = arrUserBadges[sKey];
      }
      const { [sKey]: arrMyUserBadge } = app.mergeBadesData(arrOld, arr, sKey);
      // for leagueBadges
      sKey = "leagueBadges";
      arrOld = [];
      if (arrUserBadgesOld && arrUserBadgesOld[sKey]) {
        arrOld = arrUserBadgesOld[sKey];
      }
      arr = [];
      if (arrUserBadges && arrUserBadges[sKey]) {
        arr = arrUserBadges[sKey];
      }
      const { [sKey]: arrMyLeagueBadge } = app.mergeBadesData(
        arrOld,
        arr,
        sKey
      );

      arrUserBadges = {
        ...arrUserBadges,
        userBadges: arrMyUserBadge,
        leagueBadges: arrMyLeagueBadge,
      };
      //================================
      //set in local storage
      const cookie = app.getLoginCookie();
      if (cookie) {
        // core.setLocalStorageValue(
        //   config.badgesStorage,
        //   JSON.stringify({ [cookie.UserId]: arrUserBadges })
        // );
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserBadgesLoading: false,
        isUserBadgesError: false,
        isUserBadgesSuccess: true,
        arrUserBadges: arrUserBadges,
      };
    }

    case SET_WRAPPER: {
      return { ...state, $wrapMain: action.payload };
    }

    case POST_SAVE_BADGE_NOTIFY_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isBdgNotifyLoading: true,
        isBdgNotifyError: false,
        isBdgNotifySuccess: false,
      };
    }
    case POST_SAVE_BADGE_NOTIFY_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isBdgNotifyLoading: false,
        isBdgNotifyError: true,
        isBdgNotifySuccess: false,
      };
    }
    case POST_SAVE_BADGE_NOTIFY_FULFILLED: {
      let bdgNotify = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        //console.log(action.payload.data.value);
        bdgNotify = action.payload.data.Data.Value;
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isBdgNotifyLoading: false,
        isBdgNotifyError: false,
        isBdgNotifySuccess: true,
        bdgNotify: bdgNotify,
      };
    }

    case UPDATE_USER_BADGES: {
      let arrUserBadgesNotify = null;
      let notifCount = 0;

      arrUserBadgesNotify = action.payload.nots;

      if (action.payload.notifCount > 0) {
        notifCount = action.payload.notifCount;
      }

      return {
        ...state,
        arrUserBadgesNotify: arrUserBadgesNotify,
        notifCount: notifCount,
      };
    }

    case UPDATE_UNLOCKED_BADGES: {
      const { arrBadges, arrUserBadges } = state;
      let val = [];
      if (arrBadges && arrUserBadges) {
        val = app.getUserBadgesList(arrBadges, arrUserBadges);
      }
      return {
        ...state,
        unLockedBadges: val.unLockedType,
        myBdgCount: val.count,
      };
    }

    case UPDATE_UNLOCKED_BADGES_TEAM: {
      const { arrUserBadges } = state;
      const { arrBadges, sKey } = action.payload || {};
      let arr = [];
      if (arrUserBadges && arrUserBadges[sKey]) {
        arr = arrUserBadges[sKey]; //.userBadges;
      }

      // prev commented code
      // const { [sKey]: arrMyBadge } = app.mergeBadesData(arr, arrBadges, sKey);
      // const arrUserBadgesP = {
      //   ...arrUserBadges,
      //   [sKey]: arrMyBadge,
      // };

      //new code
      const arrUserBadgesP = {
        ...arrUserBadges,
        [sKey]: arr,
      };
      //set in local storage
      const cookie = app.getLoginCookie();
      if (cookie) {
        // core.setLocalStorageValue(
        //   config.badgesStorage,
        //   JSON.stringify({ [cookie.UserId]: arrUserBadgesP })
        // );
      }
      return {
        ...state,
        arrUserBadges: arrUserBadgesP,
      };
    }
    case FETCH_USER_BADGES_AFTER_POINT_CAL_PENDING: {
      return {
        ...state,
        isUserBadgesLoading: true,
        isUserBadgesError: false,
        isUserBadgesSuccess: false,
      };
    }
    case FETCH_USER_BADGES_AFTER_POINT_CAL_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserBadgesLoading: false,
        isUserBadgesError: true,
        isUserBadgesSuccess: false,
      };
    }
    case FETCH_USER_BADGES_AFTER_POINT_CAL_FULFILLED: {
      let arrUserBadgesT = null;
      let arrBadges = [];
      let sKey = "userBadges";
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }

      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrUserBadgesT = action.payload.data.Data.Value;
        if (arrUserBadgesT && arrUserBadgesT[sKey]) {
          arrBadges = arrUserBadgesT[sKey];
        }
      }
      const { arrUserBadges } = state;
      let arr = [];
      if (arrUserBadges && arrUserBadges[sKey]) {
        arr = arrUserBadges[sKey];
      }
      const { [sKey]: arrMyBadge } = app.mergeBadesData(arr, arrBadges, sKey);
      const arrUserBadgesP = {
        ...arrUserBadges,
        [sKey]: arrMyBadge,
      };
      //set in local storage
      const cookie = app.getLoginCookie();
      if (cookie) {
        // core.setLocalStorageValue(
        //   config.badgesStorage,
        //   JSON.stringify({ [cookie.UserId]: arrUserBadgesP })
        // );
      }
      return {
        ...state,
        jErrorcode,
        arrUserBadges: arrUserBadgesP,
      };
    }
    case RESET_STORE: {
      const { objMix } = state;
      return { ...initialState, objMix: objMix };
    }
    case SHOW_HIDE_PULLTO_REFRESH: {
      const { isShowPullToRefresh } = action.payload;
      return {
        ...state,
        isShowPullToRefresh: isShowPullToRefresh
          ? state.isShowPullToRefresh + 1
          : state.isShowPullToRefresh - 1,
      };
    }

    case AKAMAI_TIMER_CALL_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isAkamaiTimerLoading: true,
        isAkamaiTimerError: false,
        isAkamaiTimerSuccess: false,
      };
    }
    case AKAMAI_TIMER_CALL_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        isAkamaiTimerLoading: false,
        isAkamaiTimerError: true,
        isAkamaiTimerSuccess: false,
      };
    }
    case AKAMAI_TIMER_CALL_FULFILLED: {
      let isAkamaiTimerValueT = "";
      if (action?.payload?.headers?.date) {
        isAkamaiTimerValueT = action?.payload?.headers?.date;
      }

      return {
        ...state,
        isAkamaiTimerLoading: false,
        isAkamaiTimerError: false,
        isAkamaiTimerSuccess: true,
        isAkamaiTimerValue: isAkamaiTimerValueT,
      };
    }

    // MY PROFILE CHANGES

    case POST_TEAM_NAME_SUBMIT_PENDING: {
      return {
        ...state,
        isTeamNameLoading: true,
        isTeamNameError: false,
        isTeamNameSuccess: false,
      };
    }

    case POST_TEAM_NAME_SUBMIT_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTeamNameLoading: false,
        isTeamNameError: true,
        isTeamNameSuccess: false,
      };
    }

    case POST_TEAM_NAME_SUBMIT_FULFILLED: {
      let teamNameResT = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        teamNameResT = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isTeamNameLoading: false,
        isTeamNameError: false,
        isTeamNameSuccess: true,
        teamNameRes: teamNameResT,
      };
    }

    case FETCH_CTR_FAV_DATA_PENDING: {
      return {
        ...state,
        isSelectDataLoading: true,
        isSelectDataError: false,
        isSelectDataSuccess: false,
      };
    }

    case FETCH_CTR_FAV_DATA_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isSelectDataLoading: false,
        isSelectDataError: true,
        isSelectDataSuccess: false,
      };
    }

    case FETCH_CTR_FAV_DATA_FULFILLED: {
      let SelectDataResT = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        SelectDataResT = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isSelectDataLoading: false,
        isSelectDataError: false,
        isSelectDataSuccess: true,
        SelectDataRes: SelectDataResT,
      };
    }

    case POST_PROFILE_UPDATE_SUBMIT_PENDING: {
      return {
        ...state,
        isProfileUpdateLoading: true,
        isProfileUpdateError: false,
        isProfileUpdateSuccess: false,
      };
    }

    case POST_PROFILE_UPDATE_SUBMIT_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isProfileUpdateLoading: false,
        isProfileUpdateError: true,
        isProfileUpdateSuccess: false,
      };
    }

    case POST_PROFILE_UPDATE_SUBMIT_FULFILLED: {
      let profileUpdateResT = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        profileUpdateResT = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isProfileUpdateLoading: false,
        isProfileUpdateError: false,
        isProfileUpdateSuccess: true,
        profileUpdateRes: profileUpdateResT,
      };
    }

    case FETCH_PROFILE_DATA_PENDING: {
      return {
        ...state,
        isProfileDateLoading: true,
        isProfileDateError: false,
        isProfileDateSuccess: false,
      };
    }

    case FETCH_PROFILE_DATA_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isProfileDateLoading: false,
        isProfileDateError: true,
        isProfileDateSuccess: false,
      };
    }

    case FETCH_PROFILE_DATA_FULFILLED: {
      let profileDateResT = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        profileDateResT = action.payload.data.Data.Value;
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isProfileDateLoading: false,
        isProfileDateError: false,
        isProfileDateSuccess: true,
        profileDateRes: profileDateResT,
      };
    }

    case SHOULD_DELETE_BOOSTER: {
      return {
        ...state,
        shouldDeleteBoosterVal: action.payload,
      };
    }

    case FETCH_CONFIG_DATA_PENDING: {
      return {
        ...state,
        isConfigDataLoading: true,
        isConfigDataError: false,
        isConfigDataSuccess: false,
      };
    }

    case FETCH_CONFIG_DATA_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isConfigDataLoading: false,
        isConfigDataError: true,
        isConfigDataSuccess: false,
      };
    }

    case FETCH_CONFIG_DATA_FULFILLED: {
      let configDataResT = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        configDataResT = {
          test: "test",
          morePage: [
            {
              title: "help",
              links: [
                {
                  Linktitle: "menuRules",
                  key: 4,
                  navLink: "rules",
                  isRelative: true,
                },
                {
                  Linktitle: "fantasy_point_system",
                  key: 1,
                  navLink: "fantasypointsystem",
                },
                {
                  Linktitle: "how_to_play",
                  key: 2,
                  navLink: "howtoplay",
                },
                {
                  Linktitle: "prizes",
                  key: 3,
                  navUrl: "https://fantasy-stage.iplt20.com/classic/prizes",
                },
              ],
              key: 3,
            },
          ],

          totalSubs: 10,
        };
      }
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isConfigDataLoading: false,
        isConfigDataError: false,
        isConfigDataSuccess: true,
        configDataRes: configDataResT,
      };
    }

    case FETCH_USER_POINTS_HISTORY_PENDING: {
      return {
        ...state,
        isUserPtsHistoryLoading: true,
        isUserPtsHistoryError: false,
        isUserPtsHistorySuccess: false,
      };
    }

    case FETCH_USER_POINTS_HISTORY_REJECTED: {
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        const jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }

      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPtsHistoryLoading: false,
        isUserPtsHistoryError: true,
        isUserPtsHistorySuccess: false,
      };
    }

    case FETCH_USER_POINTS_HISTORY_FULFILLED: {
      let userPtsHistoryResT,
        jStatusCode,
        jErrorcode = null;

      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        userPtsHistoryResT = action.payload.data.Data.Value;
      }
      if (
        action.payload.data &&
        action.payload.data.Meta &&
        action.payload.data.Meta.RetVal
      ) {
        jStatusCode = action.payload.data.Meta.RetVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPtsHistoryLoading: false,
        isUserPtsHistoryError: true,
        isUserPtsHistorySuccess: false,
        userPtsHistoryRes: userPtsHistoryResT,
      };
    }

    case GET_MY_RANK: {
      const isMyRank = action.payload;
      return {
        ...state,
        isMyRank: isMyRank,
      };
    }

    case VIEW_TEAM: {
      const viewTeam = action.payload;
      return {
        ...state,
        viewTeam: viewTeam,
      };
    }

    case BOOSTER_RESET: {
      const bstVal = action.payload;

      return {
        ...state,
        boosterReset: bstVal,
      };
    }

    default: {
      return state;
    }
  }
}
